const en = {
  //Header
  "ProfileName": "Profile Name",
  "UserRole": "User Role",
  "ChangePassword": "Change Password",
  "Profile": "Profile",
  "Logout": "Logout",
  "UnauthorizedUser": "Unauthorized User",

  //Sidebar
  "LoanPortfolio": "Loan Portfolio",
  "Operations": "Operations",
  "Collections": "Collections",
  "Accounting": "Accounting",

  //Profile
  "UserDetails": "User Details",
  "Edit": "Edit",
  "Deactivate": "Deactivate",
  "fullName": "Full Name",
  "firstName": "First Name",
  "lastName": "Last Name",
  "Role": "Role",
  "email": "email",
  "PhoneNumber": "Phone Number",
  "Save": "Save",
  "Back": "Back",
  "SelectUser": "Select User",
  "Image": "Image",
  "User": "User",
  "USER_NOT_FOUND": "No any user available to handle workload of original user.",
  "NO_REPORTING_USER_FOUND": "No reporting user found.",
  "OwnerMobileNumber": "Owner Mobile Number",
  "addZoneManually": "Zone not found for the selected branch add zone manually in the below field.",

  //ProfileMessages
  "UserCreatedSuccessfully": "User has been successfully created.",
  "UserCreatedSuccessfullyAssignmentsNotDone": "User has been successfully created.  Changes will reflect in few minutes.",
  "UserUpdatedSuccessfully": "User has been successfully updated.",

  // Login
  "Sanerret": "Sanerret",
  "LoginCopyrightText": "Copyright © $ Matrices",
  "username": "Username",
  "Password": "Password",
  "ForgotPassword": "Forgot Password",
  "Login": "Login",

  // Errors
  "Error": "Error",
  "SorryAnErrorHasOccurred":
    "Sorry an error has occurred. Please try again.",
  "NetworkNotReachable": "Failed to connect to the server.",
  "ConnectionError": "Connection Error",
  "EmptyFieldsError": "Please fill all the required fields.",
  "InvalidLoginCredentials": "Invalid credentials.",
  "InvalidMatricesCode": "Please Enter a Valid Matrices code.",
  "EmptyUsernameError": "Please enter username.",
  "EmailHasBeenSent": "email has been sent to the user.",
  "EmailNotSent": "Unable to send an email to the user.",
  "InvalidOldPassword": "Invalid old password.",
  "UserNotActive": "User is not active.",
  "UsernameAlreadyExists": "Username already exist.",
  "RoleNotFound": "Role not found.",
  "FailedToSendEmail": "Unable to send an email to the user.",
  "AccessNotFound": "Access not found!!",
  "InvalidRequestParameters": "Invalid request Parameters.",
  "SearchParametersCanNotBeAllNull":
    "Search Parameters can not be all null.",
  "ErrorNewPasswordAndConfirmPasswordAreNotSame":
    "New password and confirm password are not same.",
  "ErrorInvalidOldPassword": "Invalid old password",
  "ErrorInvalidEmail": "Invalid email",
  "ErrorInvalidBranchName": "Invalid Branch Name",
  "ACCOUNT_LOCKED_ERROR_MESSAGE":
    "Account is locked please try after sometime.",
  "NO_ANY_DOWNPAYMENT_FOUND":
    "No down payment receipt was found for today.",
  "REVERT_DOWNPAYMENT_LOAN_NOT_IN_PROCESS":
    "No appliance or motorcycle loan is currently in process for the minimart.",
  "ErrorOptionSelection": "Please select the type of payment reversal.",
  "CHOOSE_TWO_DIFFERENT_MINIMARTS": "Choose two different minimarts for merging.",
  "BRANCH_ZONE_MAPPING_NOT_PRESENT": "Please fill branch zone mapping for selected minimart: $",
  "PaymentCannotBeMade": "Payment cannot be made from this tab due to an incomplete loan form. Use the loan payment tab.",
  "oldActiveLoansPresentNote": "This minimart has following active loans $ for which payment won't be accepted by system. Please restructure mentioned loans to accept your payments.",
  "loanSpecificPayment": "For Loan ID * You can make payment upto #",
  "CannotMakePaymentForLoan": "Payment cannot be made for loan ID {0}, as it's application form data is pending",
  "InvalidInput": "Please enter a valid entry.",
  "InvalidZoneName":"Please enter valid zone name.",
  //Change Password
  "OldPassword": "Old Password",
  "NewPassword": "New Password",
  "ConfirmPassword": "Confirm Password",
  "PasswordChanged": "Password Changed",
  "YourPasswordHasBeen": "Your password has been",
  "ChangedSuccessfully": "changed successfully!",
  "LoginAgain": "Login Again",
  "Submit": "Submit",
  "Cancel": "Cancel",

  // User Management
  "UserManagement": "User Management",
  "AddUser": "Add User",
  "NoRecordsFound": "No Records Found",
  "BranchOfficer": "Branch Officer",
  "CollectionsOfficer": "Collections Officer",
  "LoanPortfolioManager": "Loan Portfolio Manager",
  "Search": "Search",
  "Refresh": "Refresh",
  "Filter": "Filter",
  "DeactivateUser": "Deactivate User",
  "ConfirmDeactivateUser":
    "Are you sure you want to deactivate the user?",
  "Yes": "Yes",
  "No": "No",
  "NoAssignee": "No Assignee",
  "ConfiguratorQuisqueya": "Configurator Quisqueya",

  //User roles
  "ADMIN": "Admin",
  "ANALYST": "Analyst",
  "CONFIGURATOR": "Configurator",
  "AUDITOR": "Auditor",
  "SALES_MODERATOR": "Sales Moderator",
  "MESSENGER_MODERATOR": "Messneger moderator",
  "OPERATIONS_OFFICER": "Operations officer",
  "OPERATIONS_MODERATOR": "Operations moderator",
  "GENERAL_MANAGER": "General manager",
  "SALES_PERSON": "Sales Person",
  "MESSENGER": "Messenger",
  "COLLECTIONS_OFFICER": "Collections officer",
  "ANALYST_MODERATOR": "Analyst moderator",
  "COLLECTIONS_MANAGER": "Collections manager",
  "COLLECTIONS_SUPERVISOR": "Collections supervisor",
  "ADMINISTRATIVE_MANAGER": "Administrative manager",
  "CUSTOMER_SERVICE": "Customer service",
  "OPERATIONS_MANAGER": "Operations manager",
  "SALES_MANAGER": "Sales manager",
  "TECHNOLOGY": "Technology",

  //Note Types
  "ANALYST_INPUT_REFERENCE": "Analyst Input Reference",
  "ANALYST_INPUT_RISK": "Analyst Input Risk",
  "ANALYST_INPUT_REGULATOR": "Analyst Input Regulator",
  "ANALYST_APPROVE": "Analyst Approve",
  "ANALYST_INCOMPLETE": "Analyst Incomplete",
  "ANALYST_REJECTION": "Analyst Rejection",
  "DOWNPAYMENT_COLLECTION": "Downpayment Collection",
  "DOWNPAYMENT_REVERSAL": "Downpayment Reversal",
  "OPERATION_OFFICER_REJECTION": "Operation Officer Rejection",
  "EVALUATION_NOTE": "Evaluation Note",
  "SELLER_LOAN": "Seller Note",
  "PAYMENT": "Payment",
  "RESCHEDULED_LOAN_DETAILS": "Rescheduled Loan Details",
  "NEGOTIATION_REQUEST": "Negotiation Request",
  "NEGOTIATION_RESPONSE": "Negotiation Response",
  "INCONSISTENT_PAYER": "Inconsistent Payer",
  "CI_MINIMART_APPROVE": "CI Minimart Approve",
  "DISMISSED_LOAN_REQUEST": "Dismissed Loan Request",
  "SIGN_UP_REQUEST": "Sign Up Request",
  "CLIENT_STATE_CHANGE": "Client State Change",
  "FOLLOW_UP": "Follow Up",
  // Version Table
  "Version": "Version",
  "State": "State",
  "LastModified": "Last Modified",
  "Active": "Active",
  "Inactive": "Inactive",
  "Drafted": "Drafted",
  "SelectVersion": "Select Version",

  // Loan Provision
  "LoanProvisions": "Loan Provisions",
  "ListOfProvisions": "List Of Provisions",

  // Loan Status
  "LoanStatus": "Loan Status",
  "LoanStatusConfig": "Loan Status Configurations",
  "Status": "Status",
  "ArrearsFrom": "Arrears in days (From)",
  "ArrearsTo": "Arrears in days (To)",
  "Notes": "Notes",
  "W_Off": "Compulsive",
  "Legal": "Legal",

  // Late Fees
  "LateFeeConfig": "Late Fee Configurations",
  "LateFees": "Late Fees",
  "LateFeesPercent": "Late Fees %",

  // Branch List
  "Name": "Name",
  "Address": "Address",
  "SelectBranchStatus": "Select Branch Status",
  "BranchManagement": "Branch Management",
  "AddBranch": "Add Branch",

  // Dashboard
  "Dashboard": "Dashboard",
  "SearchClientOrLoan": "Search Client/Loan",
  "Reports": "Reports",
  "LoanPortfolioManagement": "Loan Portfolio Management",
  "TotalLoanPortfolio": "Total Loan Portfolio",
  "TotalLoans": "Total Loans",
  "PastDue": "Past Due",
  "PastDues": "Past Dues",
  "DefaultRate": "Default Rate",
  "AvgLoanAmount": "Avg. Loan Amount",
  "AvgTerm": "Avg. Term",
  "KnowMore": "Know More",
  "Months": "Months",
  "Years": "Years",
  "DailyUpdate": "Daily Update",
  "PortfolioRepayments": "Portfolio Repayments",
  "Date": "Date",
  "Repayment": "Repayment",
  "RepaymentNo": "Repayment No.",
  "ComingSoon": "Coming Soon",
  "Amount": "Amount",
  "From": "From",
  "To": "To",
  "FilterByAmount": "Filter By Amount",
  "FilterByInterestRate": "Filter By Interest Rate",
  "FilterByTerm": "Filter By Term",
  "LoanDisbursed": "Loan Disbursed",
  "NewLoans": "New Loans",
  "Provision": "Provision",
  "DateOfDisbursement": "Date Of Disbursement",
  "View": "View",

  // Months
  "January": "Jan",
  "February": "Feb",
  "March": "Mar",
  "April": "Apr",
  "May": "May",
  "June": "Jun",
  "July": "July",
  "August": "Aug",
  "September": "Sep",
  "October": "Oct",
  "November": "Nov",
  "December": "Dec",

  //Branch Management
  "DeactivateBranch": "Deactivate Branch",
  "DoYouWantToDeactivateBranch": "Do you want to Deactivate Branch?",
  "BranchDetails": "Branch Details",
  "BranchName": "Branch Name",
  "BranchDeactivatedSuccessfully": "Branch deactivated Successfully",
  "BranchCreatedSuccessfully": "Branch Created Successfully",
  "BranchUpdatedSuccessfully": "Branch Updated Successfully",

  //Search Client/Loan
  "NameSurname": "Name/Surname",
  "LoanId": "Loan ID",
  "DateOfBirth": "Date of Birth",
  "DNINIE": "DNI/NIE",
  "FilterByBranch": "Filter by Branch",
  "WrittenOff": "Written Off",
  "AmountDisbursement": "Amount Disbursement",
  "Interest": "Interest",
  "Term": "Term",
  "Branch": "Branch",
  "DisbursementDate": "Disbursement Date",
  "CustomerId": "Customer ID",

  "ClientLoanStatus": "Client Loan Status",
  "ToPayOffLoan": "To Pay Off Loan",
  "UpToDate": "Up to Date",
  "Capital": "Capital",
  "Arrears": "Arrears",
  "OtherCharges": "Other Charges",
  "LoanStatusReport": "Loan Status Report",
  "RepaymentSchedule": "Repayment Schedule",

  "selectBranch": "Seleccione sucursal",

  //Collections
  "LoanPortfolioStatusReport": "Loan Portfolio Status Report",
  "LoanInPastDue": "Loan in past due:",
  "DaysInPastDue": "Days in past due",
  "ProvisionClassification": "Provision Classification",
  "ByCollectionsOfficer": "By Collections Officer",
  "Apply": "Apply",
  "FromDate": "From Date",
  "ToDate": "To Date",
  "Classification": "Classification",
  "DateRange": "Date Range",

  //Configurations Common
  "CreatedBy": "Created By",
  "Set": "Set",
  "Activate": "Activate",
  "SaveDraft": "Save Draft",
  "Reset": "Reset",
  "DeleteDraft": "Delete Draft",
  "Type": "Type",
  "DaysArrears_lower": "Days Arrears >=",
  "DaysArrears_upper": "Days Arrears <=",
  "PercentWithCollateral": "% with Collateral",
  "PercentWithoutCollateral": "% without Collateral",
  "BackToTheVersionList": "Are you sure you want to go back?",
  "SuccessActivate": "Configuration activated",
  "SaveAsDraft": "Save as Draft",
  "SaveAsDraftConfirmationMessage":
    "Are you sure you want to save this loan provision configuration as a draft ?",
  "ResetConfirmationMessage":
    "Are you sure you want to reset loan provision configuration changes ?",
  "ActivateConfirmationMessage":
    "Are you sure you want to activate this loan provision configuration ?",
  "DeleteDraftConfirmationMessage":
    "Are you sure you want to delete loan provision configuration draft ?",
  "SuccessReset": "Configuration data reset successfully",
  "SuccessGetDrafted": "Fetched drafted configuration",
  "SuccessGetActive": "Fetched active configuration",
  "SuccessSaveAsDraft": "Configuration saved as draft",
  "SuccessDeleteDraft": "Deleted drafted configuration",

  "ErrorConfigurationNotFound": "Configuration not found",
  "ErrorCannotUpdateConfig":
    "Not allowed to update because you are not the owner",
  "ErrorProvisionNotDrafted":
    "Provision Configuration status is not drafted",
  "ErrorConfiguration": "There was an error",
  "ErrorInvalidConfiguration": "Invalid configuration string",
  "ErrorVersionExists": "This version already exists",
  "ErrorDraftedConfigurationExists":
    "Cannot create new configuration, as there is already one drafted.",
  "ErrorConfigurationNotDrafted":
    "Configuration status is not drafted",
  "ErrorDraftedNotFound": "No drafted configuration found",
  "InvalidConfigurationData": "Invalid configuration data",
  "ErrorDraftedConfigNotFound": "No drafted configuration found",
  "ErrorActiveNotFound": "No active configuration found",
  "ErrorEmptyValue": "Input value should be non empty.",
  "DaysArrearsRangeInvalid": "Arrear's days range must not overlap.",
  "ErrorInvalidArrearDaysRange": "Invalid arrear days range",
  "ErrorDaysRangeShouldStartWithZero":
    "Range of arrears days must start with zero",
  "InvalidPercentage":
    "Invalid percentage value (must be between 0 and 100).",
  "ErrorDaysLowerMustBeLessThanDaysUpper":
    "Lower days must be less than upper days.",
  "ErrorDuplicateTypeValues":
    "Duplicate values not allowed for 'Type'",
  "ConfigurationFetchSuccessfully":
    "Configuration Fetched Successfully",
  "ErrorBranchNotFound": "Branch not found",
  "ErrorBranchNotDefined": "Branches not defined",
  "ErrorBranchAlreadyExists": "Branch with same name already exists",
  "invalidDays":"Invalid Days Entered.",
  "maxCapitalPercentage":"Maximum Percentage of Unpaid Capital (%)",
  "startCalculationFromDay":"Days of Delay",
  "fieldsCannotBeEmpty":"Fields cannot be empty.",
  "Value":"Value",
  "lateFeesPercent": "Late Fees Percent (%)",
  "GradeEWarning": "Information: Grade E is eliminated,It is for read only for the older configurations.",
  //Pagination
  "PerPage": " per page",

  //Product Catalog
  "Descripción": "Description",

  // View Loan Application
  "ViewLoanApplication": "View Loan Application",
  "LoanApplicationDetails": "Loan Application Details",
  "InvoiceNumber": "Invoice Number",
  "TotalInstallments": "Total Installments",
  "TypeOfLoan": "Type of Loan",
  "SelectCategory":"Select Category",
  "AmountPaid": "Amount Paid",
  "TotalAmount": "Total Amount",
  "BalanceAmount": "Balance Amount",
  "References": "References",
  "TypeOfReference": "Type of Reference",
  "NameOfReference": "Name of Reference",
  "TelephoneOfReference": "Telephone of Reference",
  "AddressOfReference": "Address of Reference",
  "EMICalculation": "EMI Calculation",
  "EMIDuration": "EMI Duration",
  "EMIAmount": "EMI Amount",
  "FinancialInformation": "Financial Information",
  "monthlySalesAmount": "Monthly Sales Amount",
  "accountsPending": "Accounts Pending (FIAO)",
  "inventory": "Inventory (Approx)",
  "MonthlyIncome": "Monthly Income",
  "BasicInformation": "Basic Information",
  "businessType": "Business Type",
  "Empleado": "Employee",
  "businessEstablishedSinceYears": "Business Established",
  "CalmadoTelephone": "Calmado Telephone",
  "NameOfOwner": "Name of Owner",
  "IDOfOwner": "ID of Owner",
  "MobileNumberOfOwner": "Mobile Number of Owner",
  "ownerNumber":"Mobile Number of Owner",
  "ownerAddress": "Home Address of Owner",
  "numberOfVehicles": "Number of Vehicles",
  "adminDateOfBirth": "Admin Date of Birth",
  "ownerDateOfBirth": "Owner Date of Birth",
  "ApplicationHolder": "Application Holder",
  "CustomerInfo": "Customer Information",
  "EmploymentInfo": "Employment Information",
  "customerId": "Customer ID",
  "customerMobileNumber": "Customer Mobile Number",
  "customerAddress": "Customer Address",
  "customerDateOfBirth": "Customer Date of Birth",
  "homePhone": "Home Phone",
  "employmentDuration": "Employment Duration",
  "companyName": "Company Name",
  "companyRNC": "Company RNC",
  "companyPhoneNumber": "Company Phone Number",
  "companyAddress": "Company Address",
  "salary": "Salary",
  "monthlySalary": "Monthly Salary",
  "outstandingDebts": "Outstanding Debts",
  "otherIncome": "Other Income",
  "Expenses": "Expenses",
  "numberOfEmployees": "No. of Employees",
  "salaryOfEmployees": "Salary Employee",
  "rent": "Rent",
  "electricity": "Electricity",
  "telephone": "Telephone",
  "CableInternet": "Cable/Internet",
  "GasOfDelivery": "Gas of Delivery",
  "DebtsToSuppliers": "Debts to Suppliers",
  "AdministrationInformation": "Administration Information",
  "NameOfAdministration": "Name of Administration",
  "adminId": "ID of Administration",
  "adminNumber": "Mobile No. of Administration",
  "SiteVisit": "Site Visit",
  "NoOfOwnedDeliveryMotors": "No. of Owned Delivery Motors",
  "NoOfExhibitionFridges": "No. of Exhibition Fridges",
  "NoOfBotellero": "No. of Botellero",
  "NoOfCars": "No. of Cars",
  "TypeOfLocal": "Type of Local",
  "NoOfTV": "No. of TV’s",
  "NoOfTelephone": "No. of Telephone",
  "NoOfFreezers": "No. of Freezers",
  "NoOfExhibitors": "No. of Exhibitors",
  "Evidence": "Evidence",
  "Invoice": "Invoice",
  "PhotoID": "Photo ID",
  "INSUFFICIENT_LOAN_APPLICATION_DATA": "Insufficient loan application data.",
  "Arrears_in_Days": "Arrears in Days",
  "Number_of_days_the_EMI_is_delayed": "Number of days the EMI is delayed",
  "conciliatedLoanDetailsFor": "Conciliation Loan Details for",
  "restructureDetailsFor":"Restructure Details for",
  "CreatedLoanDetails":"Details of loan created after restructuring ",
  "ClosedLoanDetails":"Details of loan closed after restructuring",
  "ClosedRestructuredLoan":"Closed Restructured Loan",
  "CreatedRestructuredLoan": "Created Restructured Loan",
  "LoanCreatedByRestructuring":"Loan generated after restructuring $ ",
  "LoanClosedByRestructuring":"This loan was restructured $ ",
  "viewMoreDetails": "View More Details",
  "closedByConciliation": "Closed by Conciliation",
  "closedByRestructuring": "Closed by Restructuring",
  "conciliationByApplicationID": "Conciliation by Application ID",
  "createdByRestructuring": "Created By Restructuring",
  "createdLoanID": "Created Loan ID",
  "closedLoanID": "Closed Loan ID",
  "ClosedApplicationID": "Closed Application ID",
  "CreatedApplicationID": "Created Application ID",
  "closed": "Closed",
  "signedCreditAgreement": "Signed Credit Agreement",
  // CI Wire Transfer
  "CIWireTransferTitle": "CI Wire Transfer",
  "TotalPaidAmount": "Total Paid Amount",
  "TotalUnPaidAmount": "Total Unpaid Amount",
  "PaidInvoiceLabel": "Paid Invoice",
  "UnPaidInvoiceLabel": "Unpaid Invoice",
  "ReportFileName": "CI_Wire_Transfer_Report",

  // Daily Status
  "created": "Created :  ",
  "disbursed": "Disbursed :  ",
  "pending": "Pending :  ",
  "USER_DEACTIVATION_FAILED":
    "Some minimarts are still associated with the user. Please remove all the zones and try to deactivate on next working day.",

  "approvedAmount": "Approved Amount",
  "Interestrate": "Interest Rate",
  "approvedInterestRate":"Approved Interest Rate (%)",
  "blockedMinimartWarning": "This minimart is blocked",
  "askToBlockTheMinimart": "Do you want to block the minimart? ",
  "askToUnlockTheMinimart": "Do you want to Unblock the minimart? ",
  "BLOCK": "BLOCK",
  "BLOCKED": "BLOCKED",
  "UNBLOCK": "UNBLOCK",
  "minimartStatusUpdatedSuccessfully": "Minimart status updated successfully",

  "SelectBranchToApprove": "Select branch to approve",
  "supervisor": "Supervisor",
  "selectSalesModerator": "Select Sales Moderator",
  "selectFileStatus": "File Status",
  "viewNote": "See note",
  "noteId": "Notes",
  "SalesPersonNotes":"Salesperson Notes",
  "referenceNotesbyAnalyst": "Reference Notes by Analyst",
  "financialRiskAssessmentNotesbyAnalyst": "Financial Risk Assessment Notes by Analyst",
  "regulatorsNotebyAnalyst": "Regulators Notes by Analyst",
  "errorEmptyNote": "Please add a note ",
  "NoteForBlackListingCedula": "Note is mandatory.",
  "NoteDetails":"Note Details",
  "applicationId(S)": "ID of Application(s)",
  "charactersAllowed": "Only characters are allowed",

  "RENTED": "RENTED",
  "OWNED": "OWNED",
  "MOTORCYCLE": "Appliances and Equipments",
  "DELETE": "DELETE",
  "OWNER": "OWNER",
  "resetGradeText": "Are you sure you want to reset the grade?",
  "RANGE": "RANGE",
  "YES_NO": "Yes or No",
  "MULTI_VALUE": "MULTI VALUE",
  "imageUploadFailed": "Image loading failed, please try again.",
  "sizeIsTooLarge":
    "The file is too large. The maximum size allowed is 5 mb",
  "fileExtension":
    "Only files with the following extensions are allowed: png, jpg, jpeg",
  "fileExtensionErrorOfTranferReceipt":
    "Only files with the following extensions are allowed: png, jpg, jpeg, pdf",
  "invalidLateFeesRequest":
    "Invalid late fees take off request. Current late fees are less than the approved take off late fees. Discarding this request!",
  "NOT_ELIGIBILE_FOR_RENEWAL":
    "Pay an amount of {{percentage}}% ({{amount}}) of the active loan ({{loanType}}) to get the new one.",
  "ExistingSalesPersonUser": "Existing SalesPerson User",
  "ExistingMessengerUser": "Existing Messenger User",
  "NewSalesPersonUser": "New SalesPerson User",
  "NewMessengerUser": "New Messenger User",
  "None": "None",
  "ChangePosition": "Change Position",
  "salesPosition":
    "The salesperson Position $ will be vacant. Please confirm.",
  "messengerPosition":
    "The messenger Position $ will be vacant. Please confirm.",
  "salesPositionAssign":
    "The Salesperson $ will be deactivated. The New Salesperson $ will be assigned at position $. Please confirm.",
  "messengerPositionAssign":
    "The Salesperson $ will be deactivated. The New Salesperson $ will be assigned at position $. Please confirm.",
  "salesSwapPosition":
    "The position of $ will be exchanged with the workload of $. Please confirm.",
  "messengerSwapPosition": " will swap position with ",
  "pleaseSelectUser": "Please select user.",
  "assignmentDoneSuccessfully": "Assignment done successfully.",
  "assignmentFailed": "Assignment Failed.",
  "searchedZones": "List of searched zones.",
  "Terms": "Términos",
  "OtherTerms": "Otros Terminos",
  "POSITION_NOT_FOUND": "Position not found.",
  "POSITION_NAME_ALREADY_PRESENT":
    "Position name is already present in the system! Please enter different position name.",
  "messengerPositionText": "Messenger Position",
  "salesPersonPostion": "Sales Person Position",
  "BRANCH_ZONE_MAPPING_NOT_FOUND": "Branch zone mapping not found.",
  "ROUTE_NOT_FOUND": "Route not found.",
  "positionNameLengthError":
    "Position name should be 5 to 7 characters.",

  "NO_MESSENGER_FOUND_FOR_NEW_MESSENGER_POSITION":
    "No messenger found for new messenger position.",
  "NO_MESSENGER_FOUND_IN_THE_ZONE":
    "Ninguna mensajera encontrada en la zona",
  "positionChanged": "The position changed successfully.",
  "positionChangedAssignmentsNotDone": "Position changed successfully. Changes will reflect in few minutes.",
  "addPosition": "The position was added successfully.",
  "NO_WORKLOAD_FOR_POSITION":
    "The position $ of zone $ do not have extra workload.",
  "INVALID_CREDIT_LIMIT_AMOUNT":
    "The requested amount must be greater than existing amount",
  "ELIGIBILITY_CRITERIA": "ELIGIBILITY_CRITERIA",
  "editPosition": "Edit Position",
  "NO_MESSENGER": "No messenger assign for zone $ of position $",
  "HigherCreditLimitErroMessage":
    "Credit limits must be lower than next levels",
  "LowerCreditLimitErrorMessage":
    "Credit limits must be higher than previous levels",
  "salesVacantPositionAssign":
    "The New Salesperson $ will be assigned at position $. Please confirm.",
  "messengerVacantPositionAssign":
    "The New Messenger $ will be assigned at position $. Please confirm.",
  "USE_WORKLOAD_MANAGEMENT_ERROR":
    "Cannot deactivate messenger user from here, use workload management.",
  "MESSENGER_POSITION_NOT_FILLED_FOR_ROUTE":
    "Messenger's position not filled for the route.",

  "signupRequestDetails": "Signup request Details",
  "matchingMinimartDetails": "Matching Minimart Details",
  "EditAssociation": "Edit Association",
  "ExistingMinimart": "Please select existing minimart.",
  "MinimartExisting": "Existing  minimart selected.",
  "minimartNotInMatricesError": "This minimart is not registered in Matrices yet, so its details cannot be updated.",
  "NOTE_NOT_FOUND": "Note not found.",
  "REQUEST_NOT_FOUND": "Request not found.",
  "MINIMART_NOT_FOUND": "minimart not found",
  "StopAssignment": "Stop Assignment",
  "StopAssignmentSuccessfully": "Stop Assignment Successfully.",
  "matchType": "Match Type",
  "CODE": "Code Matching",
  "NAME": "Name Matching",
  "OWNERID": "Owner Id Matching",
  "ADDRESS": "Address Matching",
  "minimartDetailsUpdate":
    "Minimart details were updated successfully.",
  "selectMinimartGrade": "Select Minimart Grade",
  "selectMinimartType": "Select Minimart Type",
  "selectMinimartLevel": "Select Minimart Level",
  "largetPercentage": "Larget Percentage",
  "SelectLoanType": "Type of Loan",
  "loanAmount": "Loan Amount",
  "pleaseSelectGrade": "Please select grade.",
  "pleaseSelectType": "Please select type.",
  "pleaseSelectGradeType": "Please select grade and type.",
  "remittanceError":
    "The remittance raise request has been failed due to the core server is not reachable! Please disburse this loan manually.",
  "ANALYSED_BY_SYSTEM": "Analysed By System",
  "InstallmentArrearsFrom": "Installments in arrears (Lower)",
  "InstallmentArrearsTo": "Installments in arrears (Upper)",
  "homeLocation": "Home Location",
  "socialMediaAccountDetails": "Social Media Accounts Details",
  "bankDetail": "Bank Detail",
  "CIZone": "CIZone",
  "Mother": "Mother",
  "Husband": "Husband",
  "invalidRange": "Invalid range of input",
  "conciliationApprove": "Conciliation Approve",
  "conciliationWarning":
    "Refer to the previous loan application id $ to see the details of the debt.",
  "conciliationAccess": "Conciliation Access",
  "conciliationDeatails": "Conciliation Deatails",
  "unpaidCapital": "Unpaid Capital ($)",
  "totalDebt": "Total Debt ($)",
  "atmAmount": "ATM Amount ($)",
  "editConciliationDeatails": "Edit Conciliation Deatails",
  "unpaidLateFees": "Unpaid Late Fees",
  "conciliationInterest": "Conciliation Interest",
  "conciliationLateFees": "Conciliation Late Fees",
  "conciliationHistory": "Conciliation History",
  "ssn": "This loan is created by special sales person $.",
  "loanPayOffText": "Do you want to pay off this loan?",
  "conciliationError":
    "The approved amount should be greater than the total unpaid debt of the old loan.",
  "tempPasswordSendToMobileNumber": "Temporary password will be send to",
  "loanFrom": "Loan Created from",
  "specialCharError":
    "Special characters are not allowed in the name.",
  "validUnpaidInterestError": "Enter valid unpaid interest amount.",
  "pdfDownload": "Please check your email for PDF/CSV download.",
  "addZone": "Add New Zone",
  "addedZone": "The zone was added successfully.",
  "Respectively": "respectively",
  "MINIMART_NOTES_REPORT": "Minimart_notes_report",
  "LOAN_NOTES_REPORT": "Loan_notes_report",

  //MTP PROMOTIONS
  "promotionStatus": "Promotion Status",
  "promotionType": "Promotion Type",
  "INTERNAL": "INTERNAL",
  "EXTERNAL": "EXTERNAL",
  "productType": "Product Type",
  "benefitType": "Benefit Type",
  "installment": "Installment",
  "Discount": "Discount",
  "min": "Minimum",
  "max": "Maximum",
  "rewardPointsRange": "Enter Valid reward points range.",
  "promotionCount": "Promotion Count",
  "promotionAmount": "Promotion Amount",
  "installmentIds": "Installment Ids",

  "INVALID_AMOUNT_ON_PROMOTION":
    "The requested amount is not valid for this loan due to promotion.",
  "APPROVED_BY_SYSTEM": "Aprpoved By System",
  "minLoanAmount": "Mininmum Loan Amount",
  "orderId": "Order Id",
  "orderIdError":
    "Please save the order id before disbursing the loan.",

  "MULTIPLE_ACTIVE_LOANS":
    "You have multiple active loans $. Please pay off active loans to be available for the new one.",
  "INVALID_LOAN_COMBINATION":
    "The requested loan $ does not have a valid combination with the active loans #. \n Valid combinations : ^",
  "cedulaWarning":
    "This is not a $ cedula corresponding to mini mart owner in past loans (#).",
  "cedulaMODWarning":
    "This cedula $ already exists for the minimarts #.",
  "cedulaHistory": "Cedula History",
  "downloadFrontPhoto": "Download Front Photo",
  "downloadBackPhoto": "Download Back Photo",
  "oldCedulaNumber": "Old Cedula Number",
  "newCedulaNumber": "New Cedula Number",

  //Rewards
  "RewardCatalog": "Reward Catalog",
  "AddReward": "Add Reward",
  "addRewardDetails": "Add Reward Details",
  "updateRewardDetails": "Update Reward Details",
  "expiryInMonths": "Expiry In Months",
  "expiryError": "Enter valid expiry months",
  "rewardAdded": "Reward added successfully.",
  "rewardUpdated": "Reward updated successfully",

  //Reward Approval
  "rewardApprovalFeatureTitle": "REWARDS APPROVAL PANEL",
  "rewardApprovalPageTitle": "Rewards Approval Panel",
  "rewardApprovalDetailsTitle":
    "Detalles de Aprobación de Recompensas",
  "rewardInfo": "Reward Info",
  "totalRewardPoints":
    "Reward points of minimart after approving this request will be : ",
  "PRODUCT_NOT_FOUND": "Product not found.",
  "FILE_UPLOAD_FAIL": "Failed to upload file.",
  "INSUFFICIENT_REWARD_POINTS":
    "You have insufficient reward points to order this product.",
  "rewardHistory": "Reward History",
  "rewardType": "Reward Type",
  "SPENT": "Spent",
  "EARNED": "EARNED",
  "LOAN_CLOSURE": "Loan Closure",
  "PRODUCT_PURCHASE": "Product Purchase",
  "rewardReason": "Reward Reason",
  "insuffientRewardPoints":
    "This minimart has insufficient reward points for approval. Please reject this request.",

  "creationDate": "Creation Date",
  "forgotPassword": "Forgot Password", //
  "MINIMART_BLOCKED": "Minimart is blocked.",

  "selectApprovalType": "Select Approval Type",
  "MANUAL_APPROVED": "Manual Approved",
  "AUTO_APPROVED": "Auto Approved",

  "areNeighbourReferencesSatisfactory":
    "Are neighbours reference satisfactory?", //
  "referralReward": "Referral Reward",
  "whatsAppNum": "WhatsApp number?",

  "mergeMinimart": "Merge Minimart",
  "DISABLED_MERGE_MINIMART_BUTTON": "Minimart can not be merged as messenger is not assigned",
  "merge": "Merge",
  "mergeMinimartWarning": "Minimart $ will be merge to minimart $$",
  "minimartMergedSuccessfully": "Minimart Merged Successfully",
  "mergeMinimartAlert": "Warning: The selected minmart will be removed from the system after merging.",
  "paymentReverse": "Payment Reverse",
  "paymentReverseWarning":
    "Are you sure you want to reverse all of today's payments?",
  "paymentReverseSuccessfully": "Payment Reversed Successfully.",
  "EditLoanDetails": "Edit loan details",
  "loanDetailsPdfDownloadNotAllowed": "Account statement download can be possible after disbursement of the loan.",


  //Messenger Assignment
  "assignMessenger": "Do you want to assign a messenger?",
  "messengerAssignedSuccess": "Messenger assigned successfully.",
  "messengerAssignment": "Assign a messenger",
  "DISAPPEARED": "Uncollectible",
  "PAYMENT_AGREEMENT": "PaymentAgreement",

  //Minimart Address
  "Sector": "Sector",
  "Street": "Street",
  "Reference": "Reference",

  //Add Invoice
  "AddInvoice": "Add Invoice",
  //Invoice Approval
  "invoiceApprovalPageTitle": "Invoice Approval",
  "invoiceApprovalFeatureTitle": "INVOICE APPROVAL",
  "addInvoiceSuccess": "Invoice added successfully.",
  "invoiceDetails": "Invoice Details",
  "invoiceAPPROVED": "Invoice approved successfully.",
  "invoiceREJECT": "Invoice rejected successfully.",

  //EMI Configuration
  "frequency": "Frequency",
  "WEEKLY_ONCE": "Weekly",
  "WEEKLY_TWICE": "2 times a week",
  "WEEKLY_THRICE": "3 times a week",
  "WEEKLY_SIX": "Daily",
  "MONTHLY_ONCE": "Monthly",
  "MONTHLY_TWICE": "twice a month",

  "markExceptional": "Mark Exceptional",
  "markNormal": "Mark Normal",
  "markExceptionalWarn":
    "Do you want to mark this minimart as exceptional",
  "markNormalWarn": "Do you want to mark this minimart as normal?",
  "thresholdLoanAmount": "Threshold loan amount",
  "requestedFrequency": "Requested Frequency",
  "approvedFrequency": "Approved Frequency",

  //Errors
  "PAYMENT_NOT_FOUND":
    "No payment found for that minimart or loan today.",
  "REVERT_PAYMENTS_NOT_POSSIBLE":
    "Can not revert the payments because some other action has been taken after the payment",
  "REVERT_PAYMENT_NOT_POSSIBLE_SUBSEQUENT_TRANSACTION":
    "The payment sequence for the loan is out of order.",
  "REVERT_PAYMENT_NOT_POSSIBLE_LOAN_CONCILIATED":
    "The loan was conciliated after the payment was made.",
  "REVERT_PAYMENT_NOT_POSSIBLE_OLD_LOAN_PAID":
    "The payment includes an older loan.",
  "REVERT_PAYMENT_NOT_POSSIBLE_LOAN_RESTRUCTURED":
    "The loan was closed by this payment and has since been restructured.",
  "REVERT_PAYMENT_NOT_POSSIBLE_NEW_LOAN_CREATED":
    "The loan was closed by this payment and a new loan application was created.",
  "REVERT_PAYMENT_NOT_POSSIBLE_NEW_LOAN_DISBURSED":
    "The loan was closed by this payment and a new loan was disbursed.",

  "minimartOwnerVerification":
    "Minimart owner verification details failed :",
  "REMITTANCE_RAISED_ERROR":
    "Received an error from the remittance core server while raising the remittance automatically, Please try again! ",
  "MESSENGER_ALREADY_ASSIGNED":
    "Messenger is already assigned today.",
  "NOTHING_TO_COLLECT":
    "The collection amount is zero, cannot assign messenger to a minimart.",
  "MINIMART_SPLIT_ADD_ERR":
    "Please split the minimart address into city, sector, street, number & reference to approve minimart.",
  "THE_LOAN_STATE_CANNOT_BE_CHANGED":
    "The loan state cannot be changed.",
  "INVOICE_BALANCE_ERROR":
    "The invoice balance should be less than the invoice amount.",
  "INVOICE_NOT_FOUND": "Invoice not found.",
  "ROUTE_NOT_ASSIGNED_FOR_MINIMART":
    "Route not assigned to the minimart.",
  "FREQ_ERROR": "Please select frequency.",
  "DISAPPEARED_LOAN_CANNOT_PAYOFF":
    "We cannot process payoff request for a disappeared loan.",
  "PAYMENT_CANNOT_BE_REVERTED": "Payment cannot be reverted.",
  "NOTE_INVALID_CONTEXT":"Note Context is Invalid.",
  //Meta warnings
  "Service unavailable": "Service unavailable",
  "Step timeout": "Step timeout",
  "Document number is not defined": "Document number is not defined",
  "This user has been verified more than once":
    "This user has been verified more than once",
  "Birth Date is not defined": "Birth Date is not defined",
  "Full Name is not defined": "Full Name is not defined",
  "INVALID_COLLECTION_CYCLE_CHANGE_REQUEST":
    "Cannot change collection days for Closed/Inactive loan",
  "INVALID_COLLECTION_CYCLE_CHANGE":
    "Inavalid change collection days cycle request",
  "PROVISION_SCHEME_ERROR":
    "The provision scheme has been updated with new rules. It is available for the loans disbursed after 18th February 2022.",

  //LEVEL Configuration
  "minCreditScore": "Minimum Credit Score",
  "minla": "Minimum loan amount",
  "maxla": "Maximum loan amount",
  "flma": "First loan maximum amount",
  "slma": "Second loan maximum amount",
  "minimumLoanAmountWarning":
    " Minimum loan amount should be less than maximum loan amount.",
  "maximumLoanAmountWarning":
    "Maximum loan amount should be less than or equal to Credit limit.", //
  "errorDuplicateLoanType": "Duplicate loan type",

  //Credo
  "credoCreditScore": "Credo Credit Score",
  "minCredoCreditScore": "Minimum Credo Credit Score", //
  "lowCredoCreditScoreWarning": "Credo credit score is low",

  //Credo error codes
  "CREDO_DATASET_INSIGHT_RESPONSE_PARSING_FAILED":
    "Dataset insight response parsing failed.",
  "CREDO_LOAN_APPLICATION_NOT_FOUND":
    "Loan application id not found in Credo repository.",

  "oldPasswordSameAsNew": "Old password is same as new password.",
  //Loan details screen warnings
  "EMIRoundOffWarning":
    "The unpaid capital might differ from the loan amount by some pesos because of the EMI round-off.", //
  "truckVisitDay": "Truck visit day",
  "lateFeesWarning":
    "Late fees will not be calculated for this loan because it's in a",
  "oldMinimartDetails": "Old minimart details", //

  "scalaRegistrationWarning":
    "By default existing minimart information will be saved. If you want to change any field on the basis of new request data, Please edit the information.", //

  "stopAtOperationsAmount":
    "Stop the loan at Operations if amount is greater than", //

  "sellerZones": "Seller zones",
  "messengerZones": "Messenger zones",
  "EXISTING_POSITION": "Existing position",
  "NEW_POSITION": "New position",
  "positionName": "Position Name",
  "BRANCH_CANT_BE_NULL": "Branch cannot be null",
  "ZONE_ALREADY_EXISTS": "Zone name already exists",
  "NO_MESSENGER_FOUND_FOR_GIVEN_POSITION": "Please select non vacant messenger position so that minimart cannot be orphan",
  "EXISTING_ZONE": "Existing zone",
  "NEW_ZONE": "New zone",
  "notWorking": "This feature is currently not working",
  "selectZones": "Select zones",
  "unBarMinimart": "Unbar Minimart",
  "minPaidPercent": "Loan Renewal Percentage",
  "renewalCriteria": "Renewal Criteria",
  "CASH_TOP_UP_LOAN_IS_ALREADY_ACTIVE": "The minimart already has an active cash top up loan. The requested loan cannot be approved. Please approve the loan with conciliation.",
  "INVALID_LOAN_APPROVAL_REQUEST": "The minimart already has 2 active loans. The requested loan cannot be approved. Please approve the loan with conciliation.",

  "AllMinimarts": "All minimarts",
  "scala_registered": "Scala registered",
  "non_scala_registred": "Non scala registered",
  "REPORT_FOR_DISBURSED_LOAN": "Report can only be created for disbursed loan.",
  "REPORT_NOT_AVAILABLE_FOR_OLD_LOAN": "Report is not available for old loan.",
  "AppDataIsNotFilled": "Note : This minimart has disbursed loan whose data is not filled.",
  "AppDataIsNotFilledForLoan": "Note : Application data is not filled for this loan.",
  "appliedDaysInDelays": "Applied Delay in Days",
  "appliedMaxPercentage": "Applied Max Percentage of Unpaid Capital (%)",
  "isOldLoanActiveWarning" : "Note : The payment for this loan won't be accepted. Please restructure this loan for accepting its payment.",
  //Blacklist client
  "CLIENT_PORTAL": "Client portal",
  "clientPortal": "ClientPortal",
  "clientId": "Client Id",
  "identificationNumber": "Identification number",
  "selectClientState": "Select client status",
  "noteType": "Note Type",
  "selectIdentificationType": "Select identification type",
  "identificationType": "Identification type",
  "customerName": "Customer name",
  "clientBlacklisted": "Blacklisted client",
  "CEDULA": "Cedula",
  "PASSPORT": "Passport",
  "clientStatusChange": "Changing the status of Client : ",
  "confimationWarningToBlacklist": "Are you sure you want to blacklist this client?",
  "confimationWarningToRemoveFromBlacklist": "Are you sure you want to remove this client from blacklist?",
  "activeLoansList": "Following are the active loan applications of this client:",
  "OWNER_OF_MINIMART_IS_BLACKLISTED": "Owner of minimart is blacklisted",
  "statusChangedSuccessfully": "Successfully changed the status.",
  "ALREADY_ASSIGNED_POSITION": "Already assigned position",
  "editOldMinimartDetails": "Edit old minimart details",
  "editCedula": "Edit cedula",
  "CLIENT_ALREADY_EXIST": "Client already exists.",
  "sameCedulaError": "Entered cedula id is same as old requested cedula id.",
  "CLIENT_NOT_FOUND": "Client for which Cedula needs to be updated not found in DB.",
  "INVALID_CEDULA_UPDATE_REQUEST": "Invalid cedula change is requested.",
  "CEDULA_DETAILS_MISMATCH": "Details mentioned in cedula change request are not as per system's records.",

  //Ci loan request report
  "CILoanRequestReport": "CI Loan Request Report",
  "minimartCode": "Minimart Code",
  "selectStatus": " Select Status",
  "REQUEST_CREATED": "Request Created",
  "PROCESSED_WITH_FAILURE": "Proceed with Failure",
  "CIInvoiceAmount": "Monto",
  "CIInvoiceBalanceAmount": "Balance",
  "CIInvoiceDate": "Fecha de Creación",
  "CIInvoiceExpiryDate": "Expiración",
  "CIInvoiceCreatedDate": "Fecha solicitada",
  "invalidData": "Por favor introduce un dato válido",
  "CI_LOAN_REQUEST_REPORT": "Informe_de_Solicitud_de_Préstamo_Ci",


  //Supplier configuration
  "BANK_DETAIL_CONFIGURATION": "Bank Detail Configuration",
  "bankDetailConfiguration": "/bankDetailConfiguration",
  "accountTypes": "Account Types",
  "accountType": "Account Type",
  "bankDetails": "Bank Details",
  "bankName": "Bank Name",
  "bankInfo": "Bank Information",
  "confimationWarningToDisableAccountType": "Do you want to disable the account type?",
  "confimationWarningToEnableAccountType": "Do you want to enable the account type?",
  "enableWarningOfAssociatedBanks": "Selected account type will be enabled for all the associated banks.",
  "disableWarningOfAssociatedBanks": "Selected account type will be disabled for all the associated banks.",
  "warningForBanklist": "The following banks have only one account type associated. Hence, these banks will be disabled, if this account type is disabled:",
  "activeAccount": "Account is active",
  "inActiveAccount": "Account is inactive",
  "activeBank": "Bank is active",
  "inactiveBank": "Bank is inactive",
  "minimumThreeCharacterLength": "Minimum character length should be 3.",
  "INVALID_REQUEST": "Invalid Request.",
  "REQUEST_ALREADY_EXISTS": "Request already exists.",
  "ACCOUNT_DETAILS_NOT_FOUND": "Account not found for this bank. Please add account type.",
  "transferReceipt": "Transfer Reciept",
  "FILE_UPLOAD_NOT_ALLOWED": "File upload not allowed.",
  "supplierInactiveWarning": "The selected supplier for this loan is inactive.",
  "bankInactiveWarning": "The selected bank details are inactive in the system.",
  "manageSupplier": "/manageSupplier",
  "addSupplier": "Add Supplier",
  "businessName": "Business Name",
  "contact": "Contact",
  "accountNumber": "Account Number",
  "SupplierCatalog": "Supplier Catalog",
  "updateSupplier": "Update supplier",
  "MANAGE_SUPPLIER": "MANAGE SUPPLIER",
  "supplierInfo": "Supplier Information",
  "sdt": "Selected disbursement type",
  "stat": "Selected account type",
  "Browse": "Browse",
  "DELIVERY": "Delivery",
  "TRANSFER": "Transfer",
  "PERSONAL_ACCOUNT": "PERSONAL ACCOUNT",
  "SUPPLIER_ACCOUNT": "SUPPLIER ACCOUNT",
  "TRANSFER_RECEIPT_NOT_FOUND": "Please upload transfer receipt to disburse loan.",
  "rnc": "RNC",
  "supplierAddedSuccessfully": "Supplier Added Successfully",
  "supplierUpdatedSuccessfully": "Supplier Updated Successfully",
  "bankNames": "Bank Names",
  "addAccountType": "Add Account Type",
  "addBank": "Add Bank",
  "editAccountType": "Edit Account Type",
  "selectBankStatus": "Select Bank Status",
  "selectSupplierStatus": "Select Supplier Status",
  "SUPPLIER_ALREADY_EXIST": "Supplier with the same RNC already exist.",
  "RNC_NOT_FOUND": "RNC not found",
  "RNC_SERVICE_NOT_ACCESSIBLE": "RNC service is not accessible",
  "businessNameNotValid": "Business name not valid",
  "contactNotValid": "Contact not valid",
  "phoneNumberNotValid": "Phone Number not valid",
  "bankNameNotValid": "Bank name not valid",
  "accountTypeNotValid": "Account Type not valid",
  "accountNumberNotValid": "Account Number must be in between 6 to 30 digits",
  "statusNotValid": "Status not valid",
  "ACCOUNT_NUMBER_PATTERN_MISMATCH": "Account number is not numeric.",
  "RNCVerification": "RNC Verification",
  "RNC_Unverified_Warning": "RNC for this supplier is unverified. On saving the information reverification will be attempted.",
  "Verified": "Verified",
  "UnVerified": "Unverified",
  "phoneNumber": "Telephone",
  "supplierLogo":"Supplier Logo",
  //Payment Frequencies Configuration
  "exceptional": "Exceptional",
  "nonExceptional": "Non Exceptional",
  "restructure": "Restructure ($) : ",
  "PAYMENT_FREQUENCY": "Payment frequency",
  "LeveleFreuenciesCantBeEdited": "Warning: This is an archived configuration and cannot be edited here. To edit level frequencies, see the payout frequency section.",
  //Loan Status and Grade Configuration
  "LOAN_STATUS_AND_GRADE": "Loan Staus and Grade Configuration",
  "Other": "Other",
  "repeatedDaysPastDue": "The past due days should not be repeated.",
  "repeatedTerms": "The terms should not be repeated.",
  "daysInAscendingOrder": "The grades are not in ascending order.",
  "zeroTermError": "The term cannot be 0.",
  //GeoLocation
  "GeoLocation": "Geo Location",
  "latitude": "latitude",
  "longitude": "longitude",
  "latitudeValidRange": "Latitude should be in the range of -90 to 90 degrees.",
  "longitudeValidRange": "Longitude should be in the range of -180 to 180 degrees.",

  //Deactivation
  "userAvailability": "User availability",
  "USER_CANT_DEACTIVATE_ITSELF": "You cannot deactivate yourself. Please request authorized user.",
  "USER_HAVE_SUBORDINATES": "This user have subordinates. Please distribute them in order to deactive the user.",
  "USER_HAVE_ONGOING_LOANS": "This user has work assigned for today. You can deactivate him after the work is completed.",
  "NO_ADJACENT_USER_FOUND": "Cannot deactivate the user as there is no adjacent user found in the system.",
  "USER_NOT_FOUND_TO_HANDLE_WORKLOAD": "No any user available to handle workload of original user.",
  "WorkloadDistributionModal": "Workload Distribution",
  "canDeactivateModerator": "This user does not have any subordinates. You can deactivate the user.",
  "canDeactivateUser": "This user does not have work assigned for today. You can deactivate the user.",
  "deactivated": "This user is deactivated",
  "Deactivated": "Deactivated",
  "userDeactivatedSuccessfully": "User Deactivated Successfully",

  //Unavailability
  "USER_CANT_UNAVAILABLE_ITSELF": "You cannot mark yourself unavailable. Please request authorized user.",
  "AVAILABLE_USER_HAVE_SUBORDINATES": "This user have subordinates. Please distribute them in order to mark the user unavailable.",
  "AVAILABLE_USER_HAVE_ONGOING_LOANS": "This user has work assigned for today. You can mark him unavailable after the work is completed.",
  "NO_ADJACENT_AVAILABLE_USER_FOUND": "Cannot mark the user unavailable as there is no adjacent user found in the system.",
  "ConfirmAvailableUser": "Do you want to mark this user available?",
  "ConfirmUnavailableUser": "Do you want to mark this user unavailable?",
  "Availability": "Availability",
  "canUnavailableModerator": "This user does not have any subordinates. You can mark the user unavailable.",
  "canUnavailableUser": "This user does not have work assigned for today. You can mark the user unavailable.",
  "canAvailableUser": "Do you really want to mark the user available?",
  "available": "This user is availablee",
  "unavailable": "This user is unavailable",
  "unavailableReason": "You cannot make this user unavailable because",
  "workloadCountDisplay": "Number of loans to be distributed :",
  "sameInput": "No new change to save",
  "LoansToConciliateWith": "Loans to conciliate with",
  "Available": "Available",
  "Unavailable": "Unavailable",
  "userIsUnavailableNow": "User is unavailable now.",
  "userIsAvailableNow": "User is Available now.",

  //Update loan
  "LOAN_UPDATE_NOT_ALLOWED": "Loan Update Not Alloed.",
  "ageMustBeInBetweenTwentyOneToSixtyFive": "Age must be in between 21 to 65.",
  "BASIC_INFO_CANNOT_BE_NULL": "Basic info of loan cannot be null.",
  "INVALID_BASIC_INFO_DATA": "Some fields of the basic info contains data not present in the configuration.",
  "INVALID_INCOME_DATA": "Some fields of the income contains data not present in the configuration.",
  "INVALID_SITE_VISIT_DATA": "Some fields of the site visit contains data not present in the configuration.",
  "INVALID_EXPENSES_DATA": "Some fields of the expense contains data not present in the configuration.",
  "formValuesNotPresentInConf": "Some fields of the loan application are not present in the configuration, please check.",

  //Conciliation
  "EMI_CALCULATION_NOT_FOUND": "EMI calculation not found.",
  "NEW_LOAN_AMOUNT_INSUFFICIENT_FOR_CONCILIATION": "The amount requested for the new loan is less than the repayment amount of the active loan.",
  "CASH_TOPUP_LOAN_IS_ACTIVE": "A cash top up loan is already active so any other loan can not be conciliated.",
  "RAISE_REMITTANCE_BEFORE_DISBURSEMENT": "Please raise remittance before disbursement.",
 "approvedLoanPresentError":"This business has approved loan(s) (#) with a debt of #",
  //Administrative expense configuration
  "ConfigurationManagement_ADMINISTRATIVE_EXPENSE_DATA": "ADMINISTRATIVE EXPENSE",
  "ADMINISTRATIVE_EXPENSE_DATA": "ADMINISTRATIVE EXPENSE",
  "administrativeExpense": "Administrative Expense ($)",
  "amountCharged": "Amount Charged ($)",
  "receiptIds": "Receipt Ids",

  //Change role
  "changeRole": "Change Role",
  "changeRoleWarning": "You are in the process of change role.",
  "workloadWarning": "This user has workload, You will have to distribute the workload before changing the role.",
  "notAllowedToChangeToThisRole": "You are not allowed to change to this role.",
  "USER_CANT_CHANGE_ROLE_ITSELF": "You cannot change role yourself. Please request authorized user.",
  "USER_HAVE_SUBORDINATES_TO_CHANGE_ROLE": "This user have subordinates. Please distribute them in order to change role of the user.",
  "USER_HAVE_ONGOING_LOANS_TO_CHANGE_ROLE": "This user has work assigned for today. You can change role of him after the work is completed.",
  "NO_ADJACENT_USER_FOUND_TO_CHANGE_ROLE": "Cannot change role of the user as there is no adjacent user found in the system.",
  "confirmChangeRole": "Do you want to change the role?",
  "sameRoleSelected": "You have selected the same role as the current role.",
  "userRoleChangedSuccessfully": "User role changed successfully.",

  //User roles
  "resolveComplaintNotAllowed": "You are not allowed to resolve complaint.",
  "resolveLoanRequestNotAllowed": "You are not allowed to resolve loan request.",

  //Reports admin expense
  "paidAdminExpense": "Paid Admin Expense",
  "amountCollectedInCash": "Amount Collected in Cash",
  "amountCollectedInDeposit": "Amount Collected in Deposit",
  "amountCollectedInTransfer": "Amount Collected in Transfer",
  "collectedAdminExpenseInCash": "Collected Admin Expense in Cash",

  //select collections days
  "requestedCollectionDays": "Requested Collection Days",
  "approvedCollectionDays": "Approved Collection Days",
  "st": "st",
  "nd": "nd",
  "rd": "rd",
  "th": "th",
  "mergeMinimartCollectionDaysWarning": "Information: These 2 minimarts have different collection cycles, you will need to change the collection cycle of the active loans # of the minimart $.",
  "currentCollectionCycle": "Current Collection Cycle",
  "notAllowedForThisLoanType": "It is not allowed for this type of loan.",
  "notAllowedForSelectedFrequency": "It is not allowed for selected frequency.",
  "termsUnavailable": "Terms are unavailable.",
// amortization table
  "dpd": "Days past Due",
  //Error codes
  "AMOUNT_APPROVED_CHANGE_NOT_ALLOWED": "Amount change not allowed.",
  "NO_DUE_INSTALLMENT_FOUND_FOR_CHANGIING_COLLECTION_CYCLE": "No due installment found for changing collection cycle.",
  "NEGOTIATION_UPDATE_NOT_ALLOWED": "Negotiation update not allowed.",
  "NEGOTIATION_UPDATE_BY_ANALYST": "Only the analyst can update the negotiation.",
  "NEGOTIATION_UPDATE_BY_OPERATION_USER": "Only the operation user can update the negotiation.",
  "INVALID_FREQUENCY": "Invalid frequency.",
  "INVALID_COLLECTION_DAYS": "Invalid collection days.",
  "FREQUENCY_SHOULD_NOT_BY_EMPTY": "Frequency should not be empty.",
  "MINIMART_CANNOT_BE_MARKED_NORMAL": "Minimart cannot be marked normal as it has in progress loans.",
  "INVALID_LOAN_AMOUNT_REQUEST": "Invalid loan amount is requested.",
  "INVALID_INSTALLMENT_DATE_FOR_CHANGE_COLLECTION_CYCLE": "Invalid installment date for changing collection cycle.",
  "LOAN_APPLICATION_FORM_NOT_FILLED": "The request cannot be processed as the disbursed loan's form for Loan ID $ has not been filled.",
  "disabledConfiguration": "Information: This Configuration cannot be edited here, Please refer loan status and grade configuration",
  "disableProvisionConfig": "Information: This Configuration is disabled because it has loan status D1, D2 and E, as of now we have removed this status.",
  "disabledConfig":"Information: This configuration is disabled and cannot be edited.",
  "INVALID_PROVISION_TYPE": "Provision type is invalid.",
  "TERMS_ARE_REPEATED": "Terms are repeated.",
  "DAYS_PASTDUE_ASCENDING_VERIFICATION_FAILED:": "Days past due ascending verification failed.",
  "OBSOLETE_PROVISION_TERM_CONFIGURATION": "The term configuration in provision is obsolete.",
  "OBSOLETE_CONFIGURATION":"The configuration is obsolete and no longer used.",
  "INVALID_DISCOUNT_PERCENTAGE": "Invalid discount percentage.",
  "LOAN_INTEREST_NOT_PRESENT": "Loan interest not present.",
  "SOME_ACTION_IS_PERFORMED_AFTER_DISCOUNT": "Some action is performed after discount.",
  "DISCOUNT_NOT_APPLIED": "Discount not applied.",
  "LOAN_ALREADY_CLOSED": "Loan already closed.",
  "PAYMENT_CANNOT_BE_DONE_FOR_V1_LOANS":"Payment cannot be done for V1 loans.",
  "DEPOSIT_RECEIPT_NOT_FOUND": "Deposit receipt not found.",

  //Payment collection
  "payForMinimart": "Pay for Minimart",
  "payForLoan": "Pay for Loan",
  "downpaymentCollection": "Downpayment Collection",
  "invoiceNumber": "Invoice Number",
  "todaysAmount": "Today's Amount",
  "pastDue": "Past Due",
  "clientStatus": "Client Status",
  "collectPayment": "Collect Payment",
  "payOff": "Pay Off",
  "paymentMode": "Payment Mode",
  "doYouWantNewLoan": "Do you want to apply for a new loan?",
  "DEPOSIT": "Deposit",
  "CASH": "Cash",
  "MOBILE": "Mobile",
  "WEB": "Web",
  "cashDeposited": "Collected by Deposit",
  "AdministrativeExpense": "Administrative Expense : ",
  "CollectionDetails": "Collection Details",
  "EMIAndInitialCash": "EMI and Initial cash : ",
  "CashDetails": "Cash Details : ",
  "cashInTransit": "Cash in Transit : ",
  "amountCollectedByTransfer": "Collected By Transfer: ",
  "amountCollectedBycash": "Collected by Cash : ",
  "Deposited": "Deposited",
  "transferReceipts": "Transfer Receipts",
  "paymentModes": "Payment Modes",
  "paymentSources": "Payment Sources",
  "changeReceipt": "Change File",
  "selectReceipt": "Upload File",
  "viewReceipt": "View File",
  "amountToPayOff": "Amount to pay off",
  "amountToPayShouldNotBeGreaterThanPayOff": "Amount to pay should not be greater than pay off amount.",
  "downpaymentTransferReceipt": "Downpayment Transfer Receipt",
  "paymentSource": "Payment Source",
  "paymentCollectedSuccessfully": "Payment collected successfully.",
  "downPaymentCollectedSuccessfully": "Downpayment collected successfully.",
  "INVALID_DOWNPAYMENT": "The down payment amount is less than 10% of the cost of the appliances and Equipments.",
  "MOTORCYCLE_NOT_FOUND": "Appliances and Equipments not found.",
  "LOAN_NOT_FOUND_FOR_COLLECTION": "This minimart does not have a loan for collection.",
  "COLLECTION_FAILED": "Collection failed, please try again with valid amount.",
  "DUE_LOAN_NOT_FOUND": "Due loan application not found.",
  "INSUFFICIENT_ADMINISTRATIVE_EXPENSE_AMOUNT": "Please pay the amount of $ to cover administrative expenses.",
  "FILE_NOT_FOUND": "File not found.",

  //Web payment collection reports
  "collectedBy": "Collected By",
  "webCollections": "Web Collections",
  "selectRouteDays": "Select Route Days",

  //Grade upgrade
  "UPGRADE": "UPGRADE",
  "DOWNGRADE": "DOWNGRADE",
  "changeGrade": "Change Grade",
  "MINIMART_WITH_GRADE_A_CANNOT_BE_UPGRADED": "Minimart having grade 'A' cannot be upgraded.",
  "MINIMART_WITH_GRADE_D_CANNOT_BE_DOWNGRADED": "Minimart having grade 'D' cannot be downgraded.",
  "gradeUpdateConfirmation": "Do you want to change the minimart’s grade?",
  "gradeResetConfirmation": "Do you want grade reset tonight?",
  "systemWillUpdateNote": "Note : System will update minimart grade every night.",
  "systemWillNotUpdateNote": "Note : System will not update minimart grade every night.",
  "gradeResetActive": "Grade reset active",
  "gradeResetInactive": "Grade reset inactive",
  // Deactivate Account
  "OWNER_OF_MINIMART_IS_DEACTIVATED": "This minimart has deactivated their account and registered again.",
  "DEACTIVATED": "Desactivado",
  "BL_DEACT": "Blacklisted and Deactivated",

  //Loan already closed 
  "isConciliatedLoanClosed": "The loan $ conciliated with this loan is closed.",

  //warning for Invalid date
  "warningForInvalidDate": "Please select valid date.",

  // Merged Minimarts
  "mergedMinimarts": "Merged Minimarts",
  "mergedHistory": "Merged History",
  "disbursedLoans": "Disbursed Loans",
  "rejectedLoans": "Rejected Loans",
  "inprocessLoans": "Inprocess Loans",
  "mergingApprovedOn": "Merging Approved on",
  "mergingApprovedBy": "Merging Approved by",
  "mergedMinimartHistory": "Merged minimart history",

  // Conciliation
  "NEW_LOAN_AMOUNT_NOT_SUFFICIENT": "New loan amount is not sufficient to conciliate the selected loan.",
  "ACTIVE_CASHTOPUP_LOAN_FOUND": "Cash topup loan is already active, which should be conciliated.",
  "MULTIPLE_LOANS_CANT_BE_CONCILIATED": "Only 2 loans can be conciliated.",
  "AMOUNT_IS_NOT_VALID": "Entered amount is not valid.",
  "INVALID_DAYS":"Invalid credo call days.",
  "createdByConciliation": "Created by Conciliation",
  "discountInterestAmount": "Discount Interest Amount",

  // CI Loans
  "LOAN_FORM_NOT_FILLED": "As minimart * has disbursed loan whose data is not filled yet, so you cannot approve loan # with conciliation. ",

  "RestructuringStatus": "Restructuring Status",
  "Restructured": "Involved in Restructuring",
  "NonRestructured": "Non Restructured",
  "CreatedAndClosedRestructuredLoan": "Created and Closed by Restructuring",
  "NoSellerAssignedWarning": "Seller is not assigned for minimart with CI code *.",
  "noteAddedSuccessfully": "Note Added Successfully.",
  "invalidNote": "Only letters, numbers, spaces, and special characters allowed.",
  "noteForAmortizations": "Notes for the Amortization Index : ",
  "notesForClient": "Notes for the client:",
  "addNewNote": "Add New Note",
  "existingNotes": "Existing Notes",
  "viewOrAddNote": "View or Add Note",
  
  //Apply discount screen
  "ApplyDiscount": "Aplicar Descuento",
  "calculate": "Calcular",
  "interestBeforeDiscount": "Interest Before Discount",
  "interestAfterDiscount": "Interest After Discount",
  "errorDiscountNotCalculated": "Discount not calculated.",
  "emiAfterDiscount": "EMI After Discount",
  "emiBeforeDiscount": "EMI Before Discount",
  "manualDiscountHistory": "Manual Discount History",
  "emiInterestAfterDiscount": "EMI Interest After Discount",
  "emiInterestBeforeDiscount": "EMI Interest Before Discount",
  "balanceToDateAfterDiscount": "Balance to Date After Discount",
  "balanceToDateBeforeDiscount": "Balance to Date Before Discount",
  "ipe": "Interest per EMI ($)",
  "revertDiscount": "Revert Discount",
  "discountRevertInfo": "The discount cannot be reversed if any action is taken, such as deducting late fees or payments, after the discount is applied.",
  "eliminateArrears": "Eliminate arrears to Commerce",
  "makePayment": "Make some type of payment to the business",
  "interest": "Interest",
  "ti": "Total Interest ($)",
  "ne": "EMI ($)",
  "Revert": "Revert",
  "DiscountDetails": "Discount Details",
  "revertDiscountConfirmation": "Are you sure you want to revert the discount?",
  "applyDiscountConfirmation": "Are you sure you want to apply the discount?",
  "loanInfoForDiscount": "By clicking the calculate button, we are only calculating the discount. To apply the discount, click on the apply discount button.",
  "MANUAL_DISCOUNT_APPLIED": "Manual discount applied",
  "MANUAL_DISCOUNT_REVERTED": "Manual discount reverted",
  "ApplyManualDiscount": "Apply Manual Discount",
  "po_act": "Date / Type",
  "pb_rl": "Author / Role",
  "discountRevertedSuccessfully": "Discount successfully reverted",
  "discountAppliedSuccessfully": "Discount successfully applied",
  "manualDiscount": "Manual Discount",
  "afterCalculatingDiscount": "After calculating the $ discount, the new values are",
  "PleaseTryWithOtherDiscount": "Please try with another discount",
  "viewHistory": "View History",
  "currentlyAppliedDiscountInfo": "Information about currently applied discounts",
  "afterRevertingDiscountInfo": "After reverting the discount, this previous interest and previous EMI will apply",
  "discountEmiRounding": "The interest calculated after the discount may vary due to rounding.",
  "paymentCannotBeReverted": "Today's payment cannot be reverted after applying or reverting the discount.",
  "di": "Interest to be Applied",

  // Special Prospect
  "createdBySpecialProspect": "Created by Special Prospect",
  "specialProspectMinimartNote": "Note: This is special prospect minimart.",
  "subType": "Minimart Sub Type",
  "specialProspect": "Special Prospect",
  "isMicroCredit": "Micro Credit Client",
  "matricesMinimart": "Matrices Minimart",

  // Personal loan labels
  "personalLoan": "Bank Loan",
  "PERSONAL_LOAN": "BANK LOAN",

  // New minimart approval
  "adminIDMustBeElevanDigits": "The admin ID must be 11 digits.",
  "alternateNumberMustBeTenDigits": "The alternate mobile number must be 10 digits.",
  "cedulaIdMustBeElevenDigits": "Cedula ID must be 11 digits.",
  "adminFieldsRequired": "All admin fields are required when holder type is Admin.",

  // Compulsive Messenger
  "compulsiveMessengerAssignment": "Assign Compulsive Messenger",
  "selectCompulsiveMessenger": "Select Compulsive Messenger",
  "assignCompulsiveMessenger": "Select the compulsive messenger",
  "pleaseSelectCompulsiveMessenger": "Please select the compulsive messenger",
  "compulsiveMessenger": "Compulsive Messenger",
  "visitStatus": "Visit Status",
  "messengerVisitStatus": "Messenger Visit Status",
  "COMPULSIVE_MESSENGER": "Compulsive Messenger",
  "NO_ACTION_TAKEN": "No action taken",
  "CUSTOMER_WILL_NOT_PAY": "Customer will not pay",
  "IMPOUND": "Impound",
  "complaintReport": "Complaint Report",

  "cedulaChangeWarning": "If you update the cedula, it will be changed for all following minimarts i.e. $ associated with cedula $.",
  "COMPULSIVE_MESSENGER_ALREADY_ASSIGNED": "Compulsive Messenger $ is already assigned today.",
  "compulsiveMessengerAssignedSuccess": "Compulsive messenger Assigned",
  "compulsiveMessengerHistoryNotFound": "History not found for the selected compulsive messenger",


  //CI ID
  "Remove": "Remove",
  "updateCiId": "Select ",
  "changeCiId": "Cambiar CI ID",
  "INPROCESS_FACTORING_LOANS_AVAILABLE": "There are in process factoring loans $. For changing/removing CI code you need to either reject the loan or disburse it.",
  "CI_CODE_ALREADY_PRESENT": "El código CI solicitado $ ya está asociado con el minimart $.",
  "pleaseSelectOption": "Please Select an Option",
  "pleaseEnterCIID": "Please enter CI ID",
  "CIIDSuccessMessage": "Successfully Done",
  "MINIMART_CI_CODE_CHANGE": "Minimart CI ID changed",
  "OTHER_OPERATION_ALREADY_INPROGRESS": "Other operation of minimart is already in progress. Try again after sometime.",
  
  // Legal expense configuration 
  "LEGAL_EXPENSE_CONFIG": "Legal Expenses",
  "legalExpense": "Legal Expenses",
  "ConfigurationManagement_LEGAL_EXPENSE_CONFIG": "LEGAL EXPENSES",
  "ErrorStartValueShouldBeGreaterThanZero": "The start value should be greater than zero",
  "invalidExpense": "Invalid expense",
  "legalExpenseNote": "Select the eligible loan status to which legal fees will be applied. If no loan status is selected, legal fees will not be applied.",
  "applyLegalExpenseInfoNote": "Legal fees of $ will be applied to the loan.",
  "revertLegalExpenseInfoNote": "$ in legal fees will be reverted from the loan",
  "collectedInCash": "Collected in Cash",
  "paidLegalExpense": "Paid Legal Expenses",
  "APPLY_LEGAL_EXPENSE": "Legal Expenses Applied",
  "REVERT_LEGAL_EXPENSE": "Legal Expenses Reverted",

  // Legal expense errorCodes
  "LEGAL_EXPENSE_CONFIG_IS_DISABLED": "Legal expense configuration is disabled.",
	"INVALID_LOAN_STATUS": "Status of the loan is invalid.",
	"LEGAL_EXPENSE_ALREADY_APPLIED": "Legal expense is already applied to the loan.",
	"LEGAL_EXPENSE_NOT_APPLIED_FOR_REVERSAL": "Legal expense is not applied for reverting it.",
	"LEGAL_EXPENSE_ALREADY_COLLECTED": "Legal expense is already collected.",
	"LEGAL_EXPENSE_ALREADY_REVERTED": "Legal expense is already reverted.",
	"REVERT_LEGAL_EXPENSE_FAILED": "Revert legal expense failed.",
	"APPLY_LEGAL_EXPENSE_FAILED": "Apply legal expense failed.",
	"INSUFFICIENT_LEGAL_EXPENSE_AMOUNT": "Collection amount must be greater than pending legal expense amount - $",
  "LEGAL_EXPENSE_CANNOT_BE_APPLIED_ON_CONCILIATED_LOAN": "Legal expenses cannot be applied to a loan selected for conciliation",
  "COLLECTION_EXPENSE_ALREADY_APPLIED": "Collection expense is already applied to this loan.",
  "COLLECTION_EXPENSE_NOT_APPLIED_FOR_REVERSAL": "No applied collection expense found to revert.",
  "COLLECTION_EXPENSE_ALREADY_REVERTED": "Collection expense is fully reverted or already collected, cannot revert.",
  "INVALID_COLLECTION_EXPENSE_TYPE": "Invalid collection expense type.",
  "COLLECTION_EXPENSE_CANNOT_BE_APPLIED_ON_CONCILIATED_LOAN": "Collection expense cannot be applied to a conciliated loan.",
  "APPLIED": "Applied",
  "PAID": "Paid",
  "PAYMENT_REVERTED": "Payment Reverted",
  "PARTIALLY_REVERTED": "Partially Reverted",
  "APPLY_COLLECTION_EXPENSE": "Apply Collection Expense",
  "REVERT_COLLECTION_EXPENSE": "Revert Collection Expense",
  "LOAN_WITH_PENDING_LEGAL_EXPENSE_CANNOT_BE_RESTRUCTURED": "A loan with pending legal expenses cannot be restructured",
  "LOAN_WITH_PENDING_LEGAL_EXPENSE_AMOUNT": "A loan has pending legal expenses",
  "INSUFFICIENT_ADDITIONAL_EXPENSE_AMOUNT": "Minimum amount to be paid for additional expense - $",
  "INSUFFICIENT_COLLECTION_EXPENSE_AMOUNT": "Please pay the minimum amount of $ to cover collection expense.",

  "adminExpense": "Admin Expense",
  "collectionExpense": "Collection Expense",
  "pendingAmount": "Pending Amount ($)",
  "paymentAmount": "Payment Amount ($)",
  "showReceipt": "Show Receipt",
  "legalExpenseAppliedAutomatically": "Legal fees will be automatically applied to the loan status payment agreement.",

  //Cash collection limit report for messenger
  "totalCashCollectionCredit": "Total Cash Credit Limit",
  "cashCollectionLimit": "Cash Credit Limit",
  "assignedBy": "Assigned By",
  "assignedCashLimit": "Assigned Cash Limit",
  "CANNOT_UPDATE_CASH_COLLECT_CREDIT": "The logged in user is not allowed to update cash credit limit.",
  "INSUFFICIENT_CASH_CREDIT": "Requested cash credit limit cannot be assigned to messenger as messenger has already collected amount greater than requested cash credit limit.",
  "cashCollectionCreditError": "Please enter correct cash credit limit.",
  "INVALID_AMOUNT": "Invalid amount payment.",
  "collected": "Collected",
  "limit": "Limit",

  "COL_OFF_EMI_INPUT": "Amortization Notes",

  // Loan creation
  "createLoanLabel": "Create Loan",
  "createLoanHeaderLabel": "Create Loan for Minimarket",
  "creditProducts": "Credit Product",
  "applyForLoan": "Apply for Loan",
  "selectLoanType": "Select Loan Type",
  "selectAnyLoanType": "Please select the loan type",
  "motorcycle": "Motorcycle",
  "selected": "Selected",
  "invoice": "Invoice",
  "amountChargedForTerm": "Amount charged $ for the current term",
  "pleaseSelectLoanType": "Please select the loan type",
  "EMICollection": "EMI Calculation",
  "emiAmount": "EMI Amount",
  "noOfEmi": "Number of EMI",
  "CalculateEMI": "Calculate EMI",
  "invoiceDate": "Invoice Date",
  "itemType": "Item Type",
  "pleaseSelectRecord": "Please select any record from the table to apply for a loan",
  "disbursementType": "Disbursement Type",
  "transferAccountType": "Transfer Account Type",
  "bankAccountType": "Bank Account Type",
  "bankAccountNumber": "Bank Account Number",
  "saveAndProceed": "Save and Continue",
  "poorGradeWarning": "Este minimercado tiene malas calificaciones.",
  "poorGradeBlockedWarning": "Este minimart está bloqueado y tiene malas calificaciones.",
  "legalExpenseCollected": "Legal Expense : ",
  "collectionExpenseCollected": "Collection Expense : ",
  "emiCollectedInCash": "EMI : ",
  "downpaymentCollectedInCash": "Downpayment : ",
  "loanOf": "LOAN OF ",
  "Owner": "Owner",
  "typeOfRole": "Tipo de Rol",
  "INVALID_LOAN_AMOUNT": "The requested $ loan can only be taken for an amount between * and #",
  "suggestedAmount": "Suggested quantity",
  "MONDAY,WEDNESDAY,FRIDAY": "Monday, Wednesday, Friday",
  "TUESDAY,THURSDAY,SATURDAY": "Tuesday, Thursday, Saturday",
  "AlreadyCedulaRegistered": "This cedula already exists for the minimarts *. Please make sure that the requested minimart is not already registered.",
  "MismatchPastCedulaId": "This is not a cedula corresponding to minimart owner in past loans. Do you still want to continue with this cedula?",
  "remittanceDetails": "Do you receive remittances? If so, from whom?",
  "holder": "Holder of the Application",
  "LOCAL_PHOTOS": "Local photos(5)",
  "INVOICES": "Invoices(3)",
  "LOCATION_PHOTOS": "Location Photos(5)",
  "DOCUMENT_PHOTOS": "Document Photos(3)",
  "LOCATION_PHOTO": "Location Photo",
  "DOCUMENT_PHOTO": "Document Photo",
  "PHOTOID":"Photo of ID (Front and Back)",
  "EXTERNAL_INVOICE": "External Invoices(1 or 2)",
  "webCreatedLoanUserNameNote": "This loan is created from web by $.",
  "pleaseSelectCorrectCalculationData": "Please select the correct calculation data",
  "MULTIPLE_LOANS_NOT_ALLOWED": "You are not allowed to request multiple loans.",
  "ColmadoTelephone": "Telephone",
  "DOCUMENTS_ALREADY_UPLOADED": "Document(s) already uploaded for applicationId: $ and type: $",
  "premises": "Premises",
  "DocumentAlreadyUploaded": "Document already uploaded",
  "DocumentDeleteNotAllowed": "Document cannot be deleted.",
  "ApplicationSignatureWarning": "To accept signature from matrices mobile app delete signature from here.",
  "RequestFor": "Request for",
  "CREATED": "Created",
  "INCOMPLETE": "Incomplete",
  "READY_TO_SIGN": "Ready To Sign",
  "SUBMITTED": "Submitted",
  "PENDING": "Pending",
  "ANALYSIS": "Analysis",
  "APPROVED": "Approved",
  "INPROCESS": "In Process",
  "READY_TO_APPROVE_CREDIT_LIMIT": "Ready To Approve Credit Limit",
  "READY_TO_APPROVE": "Ready To Approve",
  "INPROCESS_ANALYSIS": "In Process Analysis",
  "INPROCESS_OPERATIONS": "In Process Operations",
  "INPROCESS_ACCOUNTS": "In Process Accounts",
  "READY_TO_DISBURSE": "Ready To Disburse",
  "REJECTED_BY_ANALYST": "Rejected By Analyst",
  "DISBURSED": "Disbursed",
  "REJECTED": "Rejected",
  "IN_PROGRESS": "In Progress",
  "UP_FOR_RENEWAL": "Up For Renewal",
  "REJECTED_BY_SYSTEM": "Rejected By System",
  "DISMISSED": "Dismissed",
  "CONFIRMED": "Confirmed",
  "READY_FOR_COLLECTION": "Ready For Collection",
  "showExistingLoanDetail": "The loan is already in process with status # and amount *",
  "for": "for",
  "SUCCESS": "Success",
  "loanCreatedSuccessfully": "Préstamo creado con éxito",
  "loanFormUpdatedSuccessfully": "Formulario de préstamo actualizado correctamente",
  "Amt": "Monto($)",
  "localType": "Tipo de Local",
  "selectRecord": "Please select the $",
  "loanDismissedSuccessfully": "Loan dismissed successfully",
  "dismissLoan": "Dismiss Loan",
  "DismissLoanLoan": "Are you sure you want to cancel the loan?",
  "dismissLoanNotification": "Discard loan notification",
  "Proceed": "Proceed",
  "cedulaValidation": "Cedula Validation",
  "loanApplicationIdRequired": "Loan application ID is required",
  "loanValidationFailed": "Loan validation failed",
  "Next": "Next",
  "loanCreatedByUser": "Loan created by user",
  "uploadingFiles": "Uploading files",
  "uploading": "Uploading",
  "failedToUploadFile": "Failed to process file for upload",
  "unknownStep": "Unknown Step",
  "uploadFailed": "Upload failed",
  "noFilesToUpload": "No files to upload",
  "dismissLoanConfirmation": "Loan Dismissal Confirmation",
  "nonCiMinimartLoanNotAllowed": "Factoring CI loan is not allowed for non CI minimart.",
  //loan creation Error codes
  "AGE_NOT_ELIGIBLE": "Cannot update loan due to age not eligible.",
  "LOAN_PROCESSING_NOT_ALLOWED": "You have an insufficient credit limit! Please pay off active loans or apply for the lower amount to avail the new one.",
  "MULTIPLE_LOANS_AT_LEVEL1": "To apply for a new loan please pay off your ongoing loan.",
  "NO_CLOSED_LOAN": "Please pay off the ongoing loan first to request a new one.",
  "INVALID_AMOUNT_REQUEST": "You are not allowed to request loan amount greater than recommended amount.",
  "CREATE_FIRST_LOAN_THROUGH_MATRICES": "You need to create your first loan through matrices.",
  "LOAN_ALREADY_INPROGRESS_OF_SAME_TYPE": "Dear client, you already have a request in process of type {{requestedLoanType}}, your request will be processed shorlty.",
  "NO_SUPPLIER_SELECTED": "Please select supplier for creating loan.",
  "NO_DISBURSEMENT_TYPE_SELECTED": "Please select disbursement type for creating loan.",
  "NO_ACCOUNT_TYPE_SELECTED": "Please select account type for creating loan.",
  "INVALID_BANK_AND_ACCOUNT_TYPE": "Please select valid bank namd and account type.",
  "ACCOUNT_NUMBER_LENGTH": "Account number length should be between 8 - 20",
  "CANNOT_PROCESS_MATRICES_LOAN_IN_SCALA": "Loans created from matrices cannot be processed in scala",
  "TRANSFER_DISBURSEMENT_TYPE_ALLOWED": "Only transfer disbursement type allowed",
  "DOCUMENT_ALREADY_UPLOADED": "Document(s) already uploaded for applicationId: $ and type: $",
  "LOAN_APP_ALREADY_ASSIGNED": "Loan application already assigned.",
  "LOAN_PROCESSING_FORBIDDEN": "You have an insufficient credit limit! Please pay off active loans or apply for the lower amount to avail the new one.",
  "MINIMART_ALREADY_DEPOSITED":
    "The minimart has already made today's deposit.",

  //Premium Cash Top Up
  "LOAN_TYPE_ELIGIBILITY_CRITERIA": "CRITERIOS DE ELEGIBILIDAD DEL TIPO DE PRÉSTAMO",
  "exceptionalMinimartGrades": "Exceptional",
  "nonExceptionalMinimartGrades": "Normal",
  "minimartNotEligibleForLoanType": "The minimart is not eligible for the requested $ loan based on the loan type eligibility criteria configuration, but this loan can be approved and disbursed through the regular process.",
  "gradeDSelected": "Cannot create loan with minimart grade D.",

  "latefeesPercentageShouldNotBeGreater": "Late percentage fees cannot be greater than max capital percentage.","LATE_FEES_PERCENTAGE_CANNOT_BE_GREATER_THAN_MAX_CAPITAL_PERCENTAGE": "Late fee percentage cannot be greater than the maximum capital percentage.",
  "latefeesPercentageZeroError": "Late fee percentage cannot be zero.",
  "daysInArrearsZeroError": "Days in arrears cannot be zero.",
  "maxCapitalPercentageZeroError": "Maximum capital percentage cannot be zero.",
  "termsMustBeInAscendingOrder": "Los términos deben estar en orden ascendente.",

  // Take off late fees
  "totalLateFeesPaid": "Total amount of late fees removed",
  "takeOffLateFeesReportTab" : "Take off late fees removed",
  "lateFeesPaidReports": "Late payment amount removed",

  //EMI and Expense revert payment notes
  "EMI_AND_EXPENSE_REVERSAL": "EMI and Expenses Payment Reversal",
  "COLLECTION_NOT_COMPLETED": "Collection Not Completed",

  //Whatsapp
  "whatsApp":"WhatsApp",
  "whatsappInterest": "Whatsapp Interest",
  "WHATSAPP_INTEREST_REPORT": "Whatsapp_Interest_Report",
  "dateOfInterest": "Date of Interest",
  "firedFor": "Fired for",
  "successfullySent": " Successfully Sent",
  "whatsappNumber": "Whatsapp Number",
  "whatsappNumberAvailable": "Whatsapp Number Available",
  "noWhatsappNumber": "No Whatsapp Number",
  // Database Tables
  "DATA_ADMINISTRATOR": "Data Administrator",
  "Database": "Database",
  "DatabaseTables": "Database Tables",
  "DuplicateEntryManagement": "Duplicate Entry Management",
  "PaymentReversal": "Payment Reversal",
  "MinimartCityFix": "Minimart City Correction",
  "minimartCityFixDescription": "Upload the Excel sheet of corrected city names. Columns must be minimart_id, minimart_name, minimart_city and Fixed Text.",
  "minimartCityFixSelectFile": "Select an Excel file",
  "minimartCityFixValidate": "Validate (no changes saved)",
  "minimartCityFixApply": "Apply corrections",
  "minimartCityFixValidateFirst": "Validate the sheet and read the report before applying.",
  "minimartCityFixSummary": "Rows: {{total}} · minimart: {{minimart}} · minimart_address: {{address}} · skipped: {{skipped}}",
  "minimartCityFixDryRunDone": "Validation complete. Nothing was saved.",
  "minimartCityFixApplyDone": "Corrections applied.",
  "minimartCityFixRows": "Sheet rows",
  "minimartCityFixSkipped": "Skipped rows",
  "minimartCityFixRemaining": "Corrupted cities this sheet does not cover",
  "minimartCityFixRemainingTruncated": "The list is truncated; more corrupted rows exist than shown.",
  "minimartCityFixNoRemaining": "No corrupted city was left uncovered by this sheet.",
  "minimartCityFixNameMismatch": "Sheet name does not match the database name.",
  "sheetName": "Name (sheet)",
  "dbName": "Name (database)",
  "currentCity": "Current city",
  "currentAddressCity": "Current city (address)",
  "newCity": "Corrected city",
  "cityFixRow": "Row",
  "cityFixMinimartId": "Minimart ID",
  "cityFixReason": "Reason",
  "cityFixTable": "Table",
  "cityFixConfirm": "Confirm",
  "minimartStatus": "minimart status",
  "minimartAddressStatus": "minimart_address status",

  "MinimartBulkUpload": "Minimart Bulk Upload",
  "bulkUploadMinimartTab": "Minimart",
  "bulkUploadMicroCreditClientTab": "Micro Credit Client",
  "bulkUploadDescription": "Upload the CSV to register new minimarts. Validate first, then process a row range.",
  "bulkUploadExpectedHeaders": "Expected headers:",
  "bulkUploadSelectFile": "Select a CSV file",
  "bulkUploadValidate": "Validate CSV",
  "bulkUploadRegister": "Upload and register rows",
  "bulkUploadProcessPending": "Process pending rows",
  "bulkUploadStartRow": "Start row",
  "bulkUploadEndRow": "End row",
  "bulkUploadRowRangeRequired": "Enter both a start row and an end row.",
  "bulkUploadRowRangeInvalid": "Start row must be 1 or more and cannot exceed the end row.",
  "bulkUploadValidateDone": "CSV validated successfully. No rows were registered.",
  "bulkUploadRegisterDone": "Upload complete. Check the staging table for the per-row outcome.",
  "bulkUploadProcessPendingDone": "Pending rows processed.",
  "bulkUploadRangeNote": "Registration runs by row range so batches stay small and retryable.",
  "databaseTable": "Database Table",
  "Field": "Field",
  "Data": "Data",
  "enterLoanProcessId": "Please enter loan process id",

  // Geolocation
  "Geolocation": "Geolocation",
  "geoLocationEnabledForMessenger": "Geolocation Update by Messenger",
  "geolocationToggleInfoMessage": "Geolocation will be updated through Messenger on mobile once the toggle is enabled.",
  "INVALID_REQUEST_INVALID_GEO_LOCATION_UPDATE": "Geolocation can’t be turned off right now. Once both the seller and the messenger complete their first check‑in, you will be able to disable location updates.",
  "INVALID_REQUEST_INVALID_GEO_LOCATION_UPDATE_AFTER_SELLER_UPDATE": "Geolocation can’t be turned off right now. Once the messenger completes their first check‑in, you will be able to disable location updates.",
  "geolocationUpdateByMessengerEnabled": "Geolocation update for messenger is enabled",
  "geolocationUpdateByMessengerDisabled": "Geolocation update for messenger is disabled",

  //Collection expense config
  "COLLECTION_EXPENSE_CONFIG": "COLLECTION EXPENSE CONFIG",
  "configurationCollectionExpense":"configurationCollectionExpense",
   EXPENSE_CONFIGURATION : "COLLECTION EXPENSE CONFIG",
  "Add new configuration" : "Add new configuration",
  "ApplyExpense": "Apply Expense",
  "RevertExpense" : "Revert Expense",
  "ExpenseHistory" : "Expense History",
  "EnterPercentage" :"Enter Percentage",
  "PercentageMustbeBetweenOneToHundred" : "Percentage must be between 1 to 100",
  "action": "Action",
  "expenseType": "Expense Type",
  "percentage": "Percentage (%)",
  "APPLY": "Apply",
  "REVERT": "Revert",
  "expenseAppliedSuccessfully": "Expense applied successfully.",
  "expenseRevertedSuccessfully": "Expense reverted successfully.",
  "collectionExpenseDetails": "Collection Expense Details",
  "downloadPDF": "Download PDF",
  "downloadCSV": "Download CSV",
  "DeleteExpenseType": "Are you sure you want to delete this expense type?",

  // Duplicate Entry Management (Data Administrator)
  "duplicatesListTitle": "Duplicate rows",
  "rowsListTitle": "Rows",
  "duplicateUpdateSuccess": "Row updated successfully",
  "duplicateSearchPrompt": "Search an application id to view its rows",
  "maxIdLabel": "Max id",
  "applicationIdLabel": "Application id",
  "confirmFix": "Confirm Fix",

  // Payment Reversal (Data Administrator)
  "reversalSectionTitle": "Payment Reversal",
  "reversalSearchPrompt": "Search a section to view its rows",
  "reversalEnterSearchValues": "Enter all search values",
  "reversalDeleteSuccess": "Row deleted successfully",
  "reversalUpdateSuccess": "Row updated successfully",
  "reversalInsertSuccess": "Row added successfully",
  "reversalDeleteConfirm": "Are you sure you want to delete this row? This action cannot be undone.",
  "reversalAddRow": "Add Row",
  "actionsLabel": "Actions",
  "confirmDelete": "Confirm Delete",
  "rowDetails": "Row Details",
  "errorFetchingData": "Error fetching data",
  "fieldLabel": "Field",
  "valueLabel": "Value",
  "search": "Search",
  "none": "None",

  // Payment Reversal — per-tab notes (what to change for each table)
  "reversalNoteLabel": "What to change",
  "reversalDateLabel": "Date (created / updated)",
  "reversalNoteReceipt": "One COLLECTION receipt per payment transaction. DELETE the receipt row for the reversed payment.",
  "reversalNoteEmiReceipt": "Installment index linking receipt to amortization. DELETE the emi_receipt rows for the reversed payment.",
  "reversalNoteAmortizationV2": "Installment state. UPDATE amount_collected and status back to their pre-payment values.",
  "reversalNoteDailyOperationV2": "Ledger debit rows (CREDIT entry type). DELETE the two ledger rows created by the payment.",
  "reversalNoteDailyProcess": "Legacy ledger (may exist alongside v2). DELETE the matching rows if present.",
  "reversalNoteLoanProcess": "Loan aggregate. UPDATE amount_to_collect, unpaid_capital, unpaid_interest, unpaid_late_fees and past_due_balance.",
  "reversalNoteMinimart": "Minimart aggregate. UPDATE used_credit_limit to restore the credit freed by the reversed payment.",
  "reversalNoteMinimartLog": "Minimart change log. DELETE the used_credit_limit change entries created by the payment.",
  "reversalNoteDailyStatusMessenger": "Daily collection tracker (per messenger). UPDATE the collected amounts, EMI, administrative-expense and deposit columns.",
  "reversalNoteDailyStatusMessengerAdditionalExpense": "Daily additional-expense collection per messenger (one row per expense type). UPDATE the pending/collected additional-expense columns.",
  "reversalNoteLoanPaymentAudit": "Branch-level audit. UPDATE regular_capital_paid and regular_interest_paid (only if the payment falls in a previous month).",
  "reversalNoteLoanAudit": "Correction/audit record. INSERT a correction row (only if the payment falls in a previous month).",
  "reversalNoteLoanWorkflow": "Entry created when the loan closed. DELETE it if the reverted payment was the last payment and the loan was closed.",
  "reversalNoteMessengerCashLimitLog": "Messenger cash-limit/deposit tracking. DELETE the entries tied to the reverted deposit.",
  "reversalNoteMessengerDeposit": "Messenger deposited-cash record. DELETE if the deposit is fully reverted, otherwise UPDATE amount_deposited.",
  "reversalNoteAdditionalExpenseFeeReceipt": "Additional expense/fee receipt on the loan. DELETE the fee-receipt row created by the reversed payment, or UPDATE its amounts/entry_type.",
  "reversalNoteCollectionTransferReceiptMapping": "Bank and deposit slip record of a deposit or transfer receipt on the loan. DELETE this row before deleting its receipt (the receipt cannot be deleted while it exists), or UPDATE the bank, slip, payment mode or source.",
  "reversalNoteAdditionalExpenseFeeReceiptAudit": "Audit trail of additional expense/fee changes. DELETE the audit rows created by the reversed payment.",
  "reversalNoteAdministrativeExpenseFeeReceipt": "Administrative (processing) fee receipt on the loan. DELETE the fee-receipt row created by the reversed payment.",

  //Entry Level Approval (MC-5742)
  "EntryLevelApproval": "Entry Level Requests",
  "entryLevelRequests": "Entry Level Requests",
  "currentLevel": "Current Level",
  "requestedLevel": "Requested Level",
  "requestedBy": "Requested By",
  "approve": "Approve",
  "reject": "Reject",
  "entryLevelDecisionSuccess": "Entry level request updated successfully.",
  "PENDING_APPROVAL": "Pending Level Approval",
  "REJECTED_ENTRY_LEVEL": "Level Rejected",
  "entryLevelApprovalPendingWarning": "This customer has a pending entry level request awaiting Sales Manager or General Manager approval. The loan cannot be approved until it is decided.",
  "sellerName": "Seller Name",
  "seller": "Seller",
  "APPROVED_ENTRY_LEVEL": "Level Approved",
  "approvalDetails": "Approval Details",
  "approvedBySalesManager": "Approved By",
  "approvedDate": "Approval Date",
  "decisionDetails": "Decision Details",
  "decidedBySalesManager": "Decided By",
  "decisionDate": "Decision Date",
  "decisionNote": "Reason",
  "approveEntryLevelRequest": "Approve Entry Level Request",
  "rejectEntryLevelRequest": "Reject Entry Level Request",

  // MC-5796: entry level requested for a prospect that already exists
  "analyticsReportTimeout": "The report took too long for this range. Narrow the dates and try again.",
  "prospectLevelRequestNote": "This is a prospect minimart whose level upgrade was requested by the seller.",
  "prospectEntryLevelRequestAlreadyExists": "This prospect already has a level request awaiting approval.",
  "invalidProspectEntryLevelRequest": "The level must be above the prospect's current level and configured in the active eligibility criteria.",
  "prospectEntryLevelRequestAlreadyDecided": "This level request has already been decided.",
  "notAProspectForEntryLevel": "A level can only be requested for a prospect that has not yet been converted.",
  "approveProspectEntryLevelRequest": "Approve Prospect Level Request",
  "rejectProspectEntryLevelRequest": "Reject Prospect Level Request",
  "requestDate": "Request Date",
  "entryLevelApprovalConfirmation": "Approving confirms the customer's requested entry level and its credit limit. Add the reason for your decision - the seller will see it on the loan.",
  "entryLevelRejectionWarning": "Rejecting will mark this customer's registration as rejected, reject the loan applied for and return the customer to Level 1. Add the reason - the seller will see it on the loan.",
  "ENTRY_LEVEL_REQUESTS_REPORT": "Entry_Level_Requests_Report",
  "PROSPECT_ENTRY_LEVEL_REQUESTS_REPORT": "Prospect_Level_Requests_Report",
  "All": "All",
  "NA": "N / A",

  //Fixed collection dates - 15th and 30th (MC-5780)
  "fixedCollectionScheduleBiweekly": "Collect on the 15th and the 30th of every month",
  "fixedCollectionScheduleMonthly": "Collect on the 30th of every month",
  "fixedCollectionScheduleValueBiweekly": "It is Fixed Schedule (15th and 30th of each month)",
  "fixedCollectionScheduleValueMonthly": "It is Fixed Schedule (30th of each month)",
  "fixedCollectionScheduleTitle": "Fixed Collection Dates",
  "fixedCollectionScheduleHint": "For salaried customers paid on the 15th and the 30th. A collection date falling on a Sunday moves to the previous day. February collects on the last day of the month. No collection weekday is selected.",
  "invalidFixedCollectionScheduleFrequency": "The fixed collection dates are only available for biweekly and monthly loans.",
  "fixedCollectionCycleChangeNotAllowed": "Collection days cannot be changed for a loan on the fixed 15th and 30th collection dates.",
  "loanAlreadyOnFixedCollectionSchedule": "This loan is already on the fixed 15th and 30th collection dates.",
  "fixedCollectionScheduleNotSupportedForOldLoan": "The fixed 15th and 30th collection dates cannot be applied to this loan.",
  "noUnpaidInstallmentForFixedCollectionSchedule": "This loan has no upcoming installment to move onto the fixed collection dates.",
  "applyFixedCollectionSchedule": "Apply Fixed Collection Dates",
  "applyFixedCollectionScheduleConfirmation": "Only upcoming installments will be re-dated. Paid and overdue installments keep their original dates. This action cannot be undone.",
  "fixedCollectionScheduleApplied": "The fixed collection dates were applied to the unpaid installments.",

  // Analytics report
  "analyticsReport": "/reporteDeAnalítica",
  "AnalyticsReport": "Analytics Report",
  "analyticsReportStartYear": "Start year",
  "analyticsReportEndYear": "End year",
  "analyticsReportDownload": "Download Excel",
  "analyticsReportReset": "Reset",
  "analyticsReportFileName": "AnalyticsReport",
  "analyticsReportNoteTitle": "What this report contains",
  "analyticsReportNoteText": "An Excel workbook with one sheet per measure: loans and invoices by month, split by loan type and origin, average, smallest and largest loan, capital, interest, late fee and expense collections, payment modes, refused and reversed payments, restructured loans, closure reasons, negotiations by minimart level, active loans at each month end, and the average time from loan creation to disbursement. Figures are money collected, not amounts merely due.",
  "analyticsReportDownloaded": "The report was downloaded successfully.",
  "analyticsReportFailed": "The report could not be generated. Please try again.",
  "analyticsReportYearRequired": "Enter both a start year and an end year.",
  "analyticsReportInvalidRange": "The start year cannot be after the end year.",
  "analyticsReportYearOutOfRange": "Years must be between 2015 and the current year.",
  "analyticsReportSpanTooWide": "The range cannot be longer than 10 years.",

  // Analytics report charts
  "analyticsReportApply": "View charts",
  "analyticsChartPalette": "Colours",
  "palette_default": "Blue",
  "palette_violet": "Violet",
  "palette_ember": "Red",
  "palette_sunrise": "Amber",
  "analyticsChartNoData": "No data for the selected range.",
  "analyticsChartOther": "Other",
  "chartType_bar": "Bars",
  "chartType_stackedBar": "Stacked bars",
  "chartType_horizontalBar": "Horizontal bars",
  "chartType_line": "Line",
  "chartType_area": "Area",
  "chartType_stackedArea": "Stacked area",
  "chartType_pie": "Pie",
  "chart_monthlyLoans": "Loans disbursed by month",
  "chart_loansDisbursed": "Loans disbursed",
  "chart_disbursedAmount": "Amount disbursed by month",
  "chart_collections": "Collections by month",
  "chart_collectionsSubtitle": "Money collected, not amounts merely due",
  "chart_capital": "Capital",
  "chart_interest": "Interest",
  "chart_lateFees": "Late fees",
  "chart_expenses": "Expenses",
  "chart_revenue": "Interest and expenses collected",
  "chart_activeLoans": "Active loans",
  "chart_activeLoansSubtitle": "At each month end",
  "chart_loanType": "Loans by type",
  "chart_loans": "Loans",
  "chart_loanSource": "Loans by origin",
  "chart_paymentMode": "Collections by payment mode",
  "chart_amountCollected": "Amount collected",
  "chart_expenseType": "Expenses collected by type",
  "chart_freqTerm": "Active loans by frequency and term",
  "chart_snapshotSubtitle": "Present-day snapshot, ignores the selected years",
  "chart_negotiations": "Negotiations by minimart level",
  "chart_closures": "Loans closed by reason",

  // Analytics report date range
  "analyticsChartGranularity": "Group by",
  "granularity_AUTO": "Automatic",
  "granularity_DAY": "Day",
  "granularity_MONTH": "Month",
  "analyticsReportDateRequired": "Enter both a start date and an end date.",
  "analyticsReportDateTooEarly": "The start date cannot be earlier than 2015.",
  "analyticsReportDateInFuture": "The end date cannot be in the future.",
  "analyticsReportDayRangeTooWide": "Grouping by day is limited to a 400 day range.",

  // Analytics report enhancements
  "chart_arrears": "Portfolio at risk by days in arrears",
  "chart_provisionMix": "Book by provision grade",
  "chart_outstanding": "Outstanding principal",
  "chart_writeOffs": "Loans written off per period",
  "chart_rates": "Rates per 100 active loans",
  "chart_ratesSubtitle": "Relative to portfolio size, not absolute counts",
  "chart_closuresPer100": "Closures per 100",
  "chart_writeOffsPer100": "Write offs per 100",

  // Analytics report user experience
  "group_volume": "Volume",
  "group_collections": "Collections",
  "group_risk": "Risk",
  "group_portfolio": "Portfolio",
  "preset_thisMonth": "This month",
  "preset_lastMonth": "Last month",
  "preset_thisQuarter": "This quarter",
  "preset_yearToDate": "Year to date",
  "preset_last12Months": "Last 12 months",
  "kpi_loansDisbursed": "Loans disbursed",
  "kpi_valueDisbursed": "Value disbursed",
  "kpi_capitalCollected": "Capital collected",
  "kpi_interestCollected": "Interest collected",
  "kpi_expensesCollected": "Expenses collected",
  "kpi_loansClosed": "Loans closed",
  "kpi_activeLoans": "Active loans",
  "kpi_vsPrevious": "vs previous period",
  "kpi_noBaseline": "No comparison period",
  "kpi_today": "Today",
  "analyticsChartShowNumbers": "Show numbers",
  "analyticsChartCategory": "Category",
  "analyticsReportPreparing": "Preparing...",
  "analyticsReportWideRangeHint": "A wide range can take a few seconds.",
  "analyticsReportEmptyRange": "No activity recorded in the selected range.",
  "analyticsHeaderSub": "Portfolio, collections and risk indicators for the selected range.",
  "analyticsReportEmail": "Send by email",
  "analyticsReportEmailQueued": "The report will arrive in your email shortly.",
  "analyticsReportEmailFallback": "This range took longer than the download could wait. The report is finishing and will arrive in your email shortly.",
  "analyticsReportEmailHint": "A range longer than a month is sent by email.",
  // Deposit and transfer collections held for bank verification
  "collectionApproval": "Payment Verification",
  "collectionApprovalQueue": "Payments Awaiting Verification",
  "collectionApprovalHistory": "Payment Request History",
  "paymentRequestId": "Request",
  "allStatuses": "All statuses",
  "allPaymentModes": "All payment modes",
  "allBanks": "All banks",
  "collectionFilterMinimartId": "Matrices ID",
  "paymentRequestApproved": "Approved",
  "paymentRequestRejected": "Rejected",
  "paymentRequestReverted": "Reverted",
  "paymentRequestStatus": "Status",
  "paymentRequestDecidedBy": "Decided by",
  "destinationBank": "Destination bank",
  "selectBankToApprove": "Select the bank the money was sent to",
  "raisedBy": "Recorded by",
  "raisedOn": "Recorded on",
  "expiresOn": "Expires on",
  "viewEvidence": "View evidence",
  "downloadEvidence": "Download receipt",
  "approvePayment": "Approve",
  "rejectPayment": "Reject",
  "approvalNote": "Note",
  "rejectionNoteMandatory": "Please enter a reason for rejecting this payment.",
  "approvalNoteMandatory": "Please enter a note to approve this payment.",
  "waiveLateFeeQuestion": "Remove the late fees generated by the approval delay?",
  "accruedLateFee": "Late fees accrued while pending",
  "paymentApproved": "The payment was applied to the loan.",
  "paymentRejected": "The payment request was rejected. The loan was not changed.",
  "paymentRequestPending": "Awaiting verification",
  "paymentRequestExpired": "Expired",
  "minimartHasPendingPayment": "A payment for this minimart is awaiting bank verification. No further collection is possible until it is resolved.",
  "collectionApprovalNotFound": "The payment request was not found.",
  "collectionApprovalNotPending": "This payment request has already been decided or has expired.",
  "selectBankMandatory": "Select the bank the deposit or transfer was made to.",
  "invalidBankForPayment": "The selected bank is not available.",
  "minimartRouteChangeBlockedByPendingPayment": "The route of this minimart cannot change while a deposit or transfer is awaiting bank verification.",
  "messengerHasPendingPayments": "This messenger has deposits or transfers awaiting bank verification. Decide them before changing or deactivating the messenger.",
  "routeHasPendingPayments": "A deposit or transfer on this route is awaiting bank verification, so its messenger cannot change yet.",
  "paymentRequestLoanNotOpen": "The loan of this payment request is no longer open. Reject the request.",
  "paymentRequestEvidenceMissing": "The deposit slip of this payment request is no longer available. Reject the request.",
  "paymentRequestAssignmentMissing": "The messenger is not assigned to this minimart today. Assign the messenger manually, then approve the request.",
  "POSITION_HAS_NO_ACTIVE_USER": "The selected position has no active messenger. Choose a position with an active messenger or add the messenger with a new position.",
  "UserNotFound": "User not found.",
  "REPORTING_USER_NOT_FOUND": "The selected reporting user was not found. Please select a different reporting user.",
  "COLLECTION_OFFICER_NOT_FOUND": "The selected collection officer was not found. Please select a different collection officer.",
  "reviewAction": "Review",
  "reviewPayment": "Review payment",
  "paymentDecision": "Decision",
  "rejectionReason": "Reason for rejection",
  "uploadedReceipt": "Uploaded receipt",
  "Loading": "Loading...",
  "paymentLoan": "Loan",
  "allLoans": "All loans",
  "downPaymentRequest": "Down payment",
  "paymentRequestDetails": "Payment request details",
  "decidedBy": "Decided by",
  "decidedOn": "Decided on",
  "lateFeesWaived": "Late fees waived",
  "decisionNoteLabel": "Approval or rejection note",
};
export default en;